  (function () {
    try {
      if (typeof NodeList !== 'undefined' && NodeList.prototype && typeof NodeList.prototype.forEach !== 'function') {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }
    } catch (eNl) {}
    if (typeof Element !== 'undefined' && Element.prototype && typeof Element.prototype.closest !== 'function') {
      Element.prototype.closest = function (s) {
        var el = this;
        if (!el || el.nodeType !== 1) return null;
        var matches =
          el.matches ||
          el.webkitMatchesSelector ||
          el.msMatchesSelector ||
          function () {
            return false;
          };
        do {
          if (matches.call(el, s)) return el;
          el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
      };
    }

    /** Filterlabels horen in Actieve filters, niet in breadcrumb (voorkomt stale HTML na bfcache). */
    function ufClearBreadcrumbFilterSegments() {
      try {
        document.querySelectorAll('.uf-collection-breadcrumb-bar__text').forEach(function (wrap) {
          wrap.querySelectorAll('.uf-collection-breadcrumb-bar__pipe, .uf-collection-breadcrumb-bar__segment').forEach(function (el) {
            el.remove();
          });
        });
      } catch (eBc) {}
    }

    /** Vervangt vroeger CSS: alleen #uf-mapped-filters tonen in de sidebar; oude sort-dropdown-blokken verbergen. */
    function ufHideCollectionCssOnlyFilterUi() {
      try {
        ufClearBreadcrumbFilterSegments();
        document.querySelectorAll('.collection_page .sidebar_wrap.filters-container').forEach(function (wrap) {
          Array.prototype.forEach.call(wrap.children, function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('uf-mapped-filters')) return;
            node.hidden = true;
          });
        });
        document.querySelectorAll('.collection_page .tags-wrap').forEach(function (el) {
          el.hidden = true;
        });
      } catch (eHide) {}
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ufHideCollectionCssOnlyFilterUi);
    } else {
      ufHideCollectionCssOnlyFilterUi();
    }

    function centsToEUR(cents) {
      var n = parseFloat(cents || '0') / 100;
      return n.toFixed(2).replace('.', ',') + ' \u20ac';
    }

    /** Volledige collectie (alle pagina's) voor tellingen; gezet na fetch van ?view=uf-filter-data */
    var ufCollectionCountRows = null;
    /** Zelfde data als rijen + titel/url/afbeelding: client-side raster i.p.v. display:none */
    var ufProductCatalog = null;
    var ufFilteredProductList = [];
    var ufClientListPage = 1;
    var ufLastFilterKey = null;
    var ufFilterApplyingFromHistory = false;
    var ufFiltersHistoryReady = false;
    /** true tot eerste client-grid wipe; unfiltered page 1 behoudt SSR-LCP */
    var ufSsrGridIntact = true;
    var ufUpdateCountsTimer = null;
    var ufUpdateCountsPending = null;

    /** ?uf_group=&uf_tag=: eerste applyFilters draait vÃ³Ã³r ufSyncMerkFilterOptions â€” anders geen match â†’ reveal te vroeg (FOUC). */
    function ufColHasFilterDeeplinkParams() {
      if (window.UfFilterUrl && typeof window.UfFilterUrl.hasFilterDeeplinkParams === 'function') {
        return window.UfFilterUrl.hasFilterDeeplinkParams();
      }
      try {
        var q = new URLSearchParams(window.location.search || '');
        return !!(String(q.get('uf_group') || '').trim() && String(q.get('uf_tag') || '').trim());
      } catch (eH) {
        return false;
      }
    }
    var ufColDeferDeeplinkGridReveal = ufColHasFilterDeeplinkParams();

    function ufProductHasImageFromRow(row) {
      if (!row) return false;
      var imgs = row.images600 || row.image || row.main_600 || '';
      if (typeof imgs !== 'string' || !imgs.trim()) return false;
      var parts = imgs.split('||');
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] && String(parts[i]).trim()) return true;
      }
      return false;
    }

    function ufTileHasProductImage(tile) {
      if (!tile) return false;
      var raw = tile.getAttribute('data-product-images') || '';
      if (!raw.trim()) return false;
      var parts = raw.split('||');
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] && String(parts[i]).trim()) return true;
      }
      return false;
    }

    function ufRowsFromTiles(tiles) {
      var out = [];
      for (var i = 0; i < tiles.length; i++) {
        var el = tiles[i];
        if (!ufTileHasProductImage(el)) continue;
        var pr = parseInt(el.getAttribute('data-product-price'), 10);
        var raw = el.getAttribute('data-product-tags') || '';
        var tags = raw ? raw.split('||').filter(function (s) { return s.length > 0; }) : [];
        out.push({
          price: pr,
          tags: tags,
          title: el.getAttribute('data-product-title') || '',
          product_type: el.getAttribute('data-product-type') || '',
          vendor: el.getAttribute('data-product-vendor') || '',
          handle: el.getAttribute('data-product-handle') || ''
        });
      }
      return out;
    }

    /** geluid + waterbestendig: meerdere exacte tags met OR (data-uf-*-or met |||). */
    function ufOptionOrTagsFromBox(b) {
      var g = b.getAttribute('data-group');
      var attr = null;
      if (g === 'geluid') attr = 'data-uf-geluid-or';
      else if (g === 'waterbestendig') attr = 'data-uf-waterbestendig-or';
      else return null;
      var raw = b.getAttribute(attr);
      if (raw) {
        var parts = raw.split('|||').map(function (x) {
          return String(x || '').trim();
        }).filter(function (s) {
          return s.length > 0;
        });
        if (parts.length) return parts;
      }
      var primary = b.getAttribute('data-tag');
      return primary ? [primary] : [];
    }

    function getSelectedTags() {
      var selected = {};
      var boxes = document.querySelectorAll('#uf-mapped-filters .uf-filter-checkbox');
      boxes.forEach(function (b) {
        var group = b.getAttribute('data-group');
        var tag = b.getAttribute('data-tag');
        if (!group || !b.checked) return;
        if (group === 'geluid' || group === 'waterbestendig') {
          var gtags = ufOptionOrTagsFromBox(b);
          if (!gtags || !gtags.length) return;
          if (!selected[group]) selected[group] = [];
          for (var gi = 0; gi < gtags.length; gi++) {
            selected[group].push(gtags[gi]);
          }
          return;
        }
        if (!tag) return;
        if (!selected[group]) selected[group] = [];
        selected[group].push(tag);
      });
      if (window.__ufNavProfieltypeFilter) {
        if (!selected.profielsoort) selected.profielsoort = [];
        var navProfSoort = ufProfielsoortTagFromProfieltypeNav(window.__ufNavProfieltypeFilter);
        if (navProfSoort && selected.profielsoort.indexOf(navProfSoort) === -1) {
          selected.profielsoort.push(navProfSoort);
        }
      }
      if (window.__ufNavKleurtypeFilter) {
        if (!selected.kleurtype) selected.kleurtype = [];
        if (selected.kleurtype.indexOf(window.__ufNavKleurtypeFilter) === -1) {
          selected.kleurtype.push(window.__ufNavKleurtypeFilter);
        }
      }
      return selected;
    }

    var UF_LAYOUT_ALLOWED = { 'hongaarse punt': true, 'rechte plank': true, tegel: true, visgraat: true, 'walvisgraat xl': true, 'weense punt': true };

    /** Zelfde heuristiek als homepage-legpatroon-carousel (visgraat XL in titel/type). */
    function ufWalvisgraatXlFromText(title, productType) {
      var blob = (String(title || '') + ' ' + String(productType || '')).toLowerCase();
      return blob.indexOf('visgraat xl') !== -1 || blob.indexOf('walvisgraat') !== -1;
    }

    /** Zelfde logica als Liquid/nav: alleen Lay-out: met vaste waarden. */
    function ufNormalizeSoortTag(tag) {
      var raw = String(tag || '');
      var t = raw.toLowerCase();
      var i = t.indexOf('lay-out:');
      if (i === -1) return '';
      var key = raw.slice(i + 'lay-out:'.length).trim().toLowerCase();
      return UF_LAYOUT_ALLOWED[key] ? key : '';
    }

    /** Import-CSV: lay-out ook in product_type, bv. `Plak Â· Hongaarse punt Â· Weense punt`. */
    function ufSoortKeysFromProductTypeBlob(title, productType) {
      var blob = (String(title || '') + ' Â· ' + String(productType || '')).toLowerCase();
      var keys = {};
      for (var oi = 0; oi < UF_LAYOUT_ORDER.length; oi++) {
        var lk = UF_LAYOUT_ORDER[oi];
        var lbl = (UF_LAYOUT_LABELS[lk] || '').toLowerCase();
        if (lbl && blob.indexOf(lbl) !== -1) keys[lk] = true;
      }
      return keys;
    }

    function ufSoortKeysFromProduct(tags, title, productType) {
      var keys = {};
      var isWalvisXl = ufWalvisgraatXlFromText(title, productType);
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufNormalizeSoortTag(tags[i]);
        if (!k) continue;
        if (isWalvisXl && k === 'visgraat') continue;
        keys[k] = true;
      }
      var inferred = ufSoortKeysFromProductTypeBlob(title, productType);
      for (var ik in inferred) {
        if (Object.prototype.hasOwnProperty.call(inferred, ik)) {
          if (isWalvisXl && ik === 'visgraat') continue;
          keys[ik] = true;
        }
      }
      if (isWalvisXl) keys['walvisgraat xl'] = true;
      return keys;
    }

    function tileMatchesSoort(tileTags, selectedSoortTags, title, productType) {
      if (!selectedSoortTags || selectedSoortTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedSoortTags.length; i++) {
        var k = ufNormalizeSoortTag(selectedSoortTags[i]);
        if (k) want[k] = true;
      }
      var have = ufSoortKeysFromProduct(tileTags, title, productType);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    var UF_LAYOUT_LABELS = {
      'hongaarse punt': 'Hongaarse punt',
      'rechte plank': 'Rechte plank',
      tegel: 'Tegel',
      visgraat: 'Visgraat',
      'walvisgraat xl': 'Walvisgraat XL',
      'weense punt': 'Weense punt'
    };
    var UF_LAYOUT_ORDER = ['hongaarse punt', 'rechte plank', 'tegel', 'visgraat', 'walvisgraat xl', 'weense punt'];

    function ufLayoutLabelFromKey(key) {
      return UF_LAYOUT_LABELS[key] || '';
    }

    /** Canonieke tag-string (urbanfloors_shopify_import.csv: `Lay-out: Weense punt`, enz.). */
    function ufCanonicalLayoutTagFromKey(key) {
      var label = ufLayoutLabelFromKey(key);
      return label ? 'Lay-out: ' + label : '';
    }

    /** Altijd alle 6 lay-outs; catalogus levert exacte tag-variant indien afwijkend. */
    function ufCollectSoortLayoutTagsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var prod = catalog[pi];
        var tags = prod.tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          var k = ufNormalizeSoortTag(raw);
          if (!k) continue;
          var prev = byKey[k];
          if (!prev || String(raw).length > String(prev).length) byKey[k] = raw;
        }
        if (ufWalvisgraatXlFromText(prod.title, prod.product_type) && !byKey['walvisgraat xl']) {
          byKey['walvisgraat xl'] = 'Lay-out: Walvisgraat XL';
        }
      }
      var out = [];
      for (var oi = 0; oi < UF_LAYOUT_ORDER.length; oi++) {
        var ok = UF_LAYOUT_ORDER[oi];
        out.push(byKey[ok] || ufCanonicalLayoutTagFromKey(ok));
      }
      return out;
    }

    /** Altijd 6 lay-outs in vaste volgorde; exacte tag uit catalogus of canoniek `Lay-out: â€¦`. */
    function ufEnsureSoortFilterOptions(rootEl, catalog) {
      if (rootEl) {
        if (rootEl.getAttribute('data-uf-plinten') === 'true') return;
        if (rootEl.getAttribute('data-uf-accessoires') === 'true') return;
      }
      var ul = rootEl.querySelector('#uf-soort-filter-list') || rootEl.querySelector('#uf-collapse-soort ul');
      if (!ul) return;

      var checkedKeys = {};
      ul.querySelectorAll('input[data-group="soort"]').forEach(function (inp) {
        if (!inp.checked) return;
        var ck = ufNormalizeSoortTag(inp.getAttribute('data-tag'));
        if (ck) checkedKeys[ck] = true;
      });

      var tagByKey = {};
      ufCollectSoortLayoutTagsFromCatalog(catalog || []).forEach(function (tag) {
        var k = ufNormalizeSoortTag(tag);
        if (k) tagByKey[k] = tag;
      });
      for (var oi = 0; oi < UF_LAYOUT_ORDER.length; oi++) {
        var ok = UF_LAYOUT_ORDER[oi];
        if (!tagByKey[ok]) tagByKey[ok] = ufCanonicalLayoutTagFromKey(ok);
      }

      ul.innerHTML = '';
      for (var oi2 = 0; oi2 < UF_LAYOUT_ORDER.length; oi2++) {
        var key = UF_LAYOUT_ORDER[oi2];
        var tag = tagByKey[key];
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'soort');
        inp.setAttribute('data-tag', tag);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
        if (checkedKeys[key]) inp.checked = true;
        var ui = document.createElement('span');
        ui.className = 'uf-check-ui';
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = ufLayoutLabelFromKey(key) || tag.replace(/^[^:]+:\s*/, '').trim();
        lab.appendChild(inp);
        lab.appendChild(ui);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    /** Type-filter: tags `Soort filter: â€¦` en fallback `Soort: â€¦` (o.a. Tarkett-import). */
    var UF_PVCTYPE_FILTER_KEYS = ['click', 'loose lay', 'plak'];
    var UF_PVCTYPE_FILTER_ALLOWED = { click: true, 'loose lay': true, plak: true };

    function ufIsStandardPvctypeFilterContext(rootEl) {
      if (!rootEl) return true;
      if (rootEl.getAttribute('data-uf-traprenovatie') === 'true') return false;
      if (rootEl.getAttribute('data-uf-accessoires') === 'true') return false;
      if (rootEl.getAttribute('data-uf-plinten') === 'true') return false;
      return true;
    }

    function ufIsAllowedPvctypeKey(key, rootEl) {
      if (!ufIsStandardPvctypeFilterContext(rootEl)) return true;
      return !!UF_PVCTYPE_FILTER_ALLOWED[key];
    }

    function ufNormalizePvctypeValue(value) {
      var normalized = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (normalized === 'dryback' || normalized === 'dry-back') return 'plak';
      if (normalized === 'klik') return 'click';
      return normalized;
    }

    /** Zelfde sleutel voor URL/deeplink, checkbox en product-tags (Soort filter: vs Soort:). */
    function ufFilterSelectionKey(group, tag) {
      var g = String(group || '').trim();
      var raw = String(tag || '').trim();
      if (!raw) return '';
      if (g === 'merk') return ufMerkLabelFromTag(raw).toLowerCase();
      if (g === 'pvctype') return ufPvctypeKeyFromTag(raw);
      if (g === 'assortiment') return ufAssortimentKeyFromTag(raw);
      if (g === 'productgroep') return ufProductgroepKeyFromTag(raw);
      if (g === 'accsoort') return ufAccsoortKeyFromTag(raw);
      if (g === 'soort') return ufNormalizeSoortTag(raw);
      if (g === 'profieltype') return ufProfieltypeKeyFromNavTag(raw);
      if (g === 'plintsoort') return ufPlintsoortKeyFromTag(raw);
      if (g === 'profielsoort') return ufProfielsoortKeyFromTag(raw);
      if (g === 'plinthoofdsoort') return ufPlinthoofdsoortKeyFromTag(raw);
      if (g === 'hoogte') return ufHoogteKeyFromTag(raw);
      if (g === 'dikte') return ufDikteKeyFromTag(raw) || raw;
      if (g === 'kleur' || g === 'kleurtype') return raw.toLowerCase();
      return raw;
    }

    function ufFilterTagsEquivalent(group, tagA, tagB) {
      if (!tagA || !tagB) return false;
      if (String(tagA).trim() === String(tagB).trim()) return true;
      return ufFilterSelectionKey(group, tagA) === ufFilterSelectionKey(group, tagB);
    }

    function ufPvctypeKeyFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      if (c === -1) return '';
      var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
      if (head === 'soort filter' || head === 'soort' || head === 'pvctype' || head === 'assortiment') {
        return ufNormalizePvctypeValue(raw.slice(c + 1));
      }
      return '';
    }

    function ufPvctypeKeysFromProduct(tileTags) {
      var keys = {};
      for (var i = 0; i < (tileTags || []).length; i++) {
        var k = ufPvctypeKeyFromTag(tileTags[i]);
        if (k) keys[k] = true;
      }
      var rootEl = document.getElementById('uf-mapped-filters');
      if (rootEl && rootEl.getAttribute('data-uf-accessoires') === 'true' && ufAccessoiresHasSchoonmaakAccsoort(tileTags)) {
        keys.schoonmaakspullen = true;
      }
      return keys;
    }

    function ufPvctypeLabelFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      var label = c === -1 ? raw.trim() : raw.slice(c + 1).trim();
      var key = ufNormalizePvctypeValue(label);
      if (key === 'plak') return 'Plak';
      return label;
    }

    function ufVgroevenKeyFromTag(tag) {
      var raw = String(tag || '');
      var tl = raw.toLowerCase();
      var c = raw.indexOf(':');
      if (c === -1) return '';
      var head = raw.slice(0, c).trim().toLowerCase();
      var headKey = head.replace(/[\s_-]+/g, '');
      if (headKey === 'vgroeven') {
        return raw.slice(c + 1).trim().toLowerCase().replace(/\s+/g, ' ');
      }
      if (headKey === 'specificatie' && tl.indexOf('v-groeven') !== -1) {
        var m = raw.match(/v-groeven[^:]*:\s*(.+)/i);
        if (m) return m[1].trim().toLowerCase().replace(/\s+/g, ' ');
      }
      return '';
    }

    function ufSlijtlaagKeyFromTag(tag) {
      var raw = String(tag || '');
      var tl = raw.toLowerCase();
      var c = raw.indexOf(':');
      if (c === -1) return '';
      var head = raw.slice(0, c).trim().toLowerCase();
      var headKey = head.replace(/[\s_\-()]+/g, '');
      if (headKey === 'diktetoplaagmm' || headKey === 'slijtlaagmm' || headKey === 'slijtlaag') {
        var tail = raw
          .slice(c + 1)
          .trim()
          .toLowerCase()
          .replace(',', '.')
          .replace(/\s+/g, '')
          .replace(/mm/g, '');
        var n = parseFloat(tail);
        if (!isFinite(n)) return '';
        return String(Math.round(n * 1000) / 1000);
      }
      if (headKey === 'specificatie' && (tl.indexOf('slijtlaag') !== -1 || tl.indexOf('dikte toplaag') !== -1)) {
        var sm = raw.match(/(?:slijtlaag|dikte toplaag)[^:]*:\s*([\d]+[.,]?\d*)/i);
        if (sm) {
          var sn = parseFloat(sm[1].replace(',', '.'));
          if (isFinite(sn)) return String(Math.round(sn * 1000) / 1000);
        }
      }
      return '';
    }

    function ufNormalizeMeasureNum(v) {
      var n = parseFloat(String(v || '').replace(',', '.').replace(/mm/gi, '').trim());
      if (!isFinite(n)) return '';
      return String(Math.round(n * 1000) / 1000);
    }

    var UF_LENGTE_FORMAT_MAP = {
      'extra grote visgraat': '75-100 cm',
      'extra kleine visgraat': '50-75 cm',
      'standaard plank': '150-175 cm',
      'extra lange plank': '150-175 cm'
    };

    function ufParseGroepRangeLabel(label) {
      var m = String(label || '').match(/([\d.,]+)\s*-\s*([\d.,]+)/);
      if (!m) return null;
      return {
        min: parseFloat(m[1].replace(',', '.')),
        max: parseFloat(m[2].replace(',', '.'))
      };
    }

    function ufBuildGroepRangesFromFilter(groupName) {
      var ranges = [];
      document.querySelectorAll('#uf-mapped-filters input[data-group="' + groupName + '"]').forEach(function (inp) {
        var tag = inp.getAttribute('data-tag') || '';
        var gm = tag.match(/groep:\s*(.+)$/i);
        if (!gm) return;
        var key = gm[1].trim().toLowerCase();
        var r = ufParseGroepRangeLabel(key);
        if (!r) return;
        ranges.push({ key: key, min: r.min, max: r.max });
      });
      ranges.sort(function (a, b) {
        return b.min - a.min;
      });
      return ranges;
    }

    function ufCmToGroepKey(cm, ranges) {
      if (!isFinite(cm) || !ranges || !ranges.length) return '';
      for (var i = 0; i < ranges.length; i++) {
        if (cm >= ranges[i].min && cm <= ranges[i].max) return ranges[i].key;
      }
      return '';
    }

    function ufSpecCmFromTags(tags, specLabel) {
      var re = new RegExp(specLabel + '\\s*\\([^)]*\\):\\s*([\\d.,]+)', 'i');
      for (var i = 0; i < (tags || []).length; i++) {
        var m = String(tags[i]).match(re);
        if (m) return parseFloat(m[1].replace(',', '.'));
      }
      return NaN;
    }

    function ufDimsFromTitle(title) {
      var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*[x\u00d7]\s*(\d+(?:[.,]\d+)?)/i);
      if (!m) return null;
      return {
        w: parseFloat(m[1].replace(',', '.')),
        l: parseFloat(m[2].replace(',', '.'))
      };
    }

    function ufLengteGroepKeyFromTag(tag) {
      var m = String(tag || '').match(/plank lengte groep:\s*(.+)/i);
      return m ? m[1].trim().toLowerCase() : '';
    }

    function ufLengteGroepKeysFromProduct(tags, title) {
      var keys = {};
      var ranges = window.__ufGroepRangesLengte || [];
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufLengteGroepKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      var cm = ufSpecCmFromTags(tags, 'lengte');
      if (isFinite(cm)) {
        var g = ufCmToGroepKey(cm, ranges);
        if (g) keys[g] = true;
      }
      for (var j = 0; j < (tags || []).length; j++) {
        var tl = String(tags[j]).toLowerCase();
        if (tl.indexOf('formaat:') === -1) continue;
        var fmt = String(tags[j]).split(':').slice(1).join(':').trim().toLowerCase();
        for (var fk in UF_LENGTE_FORMAT_MAP) {
          if (Object.prototype.hasOwnProperty.call(UF_LENGTE_FORMAT_MAP, fk) && fmt.indexOf(fk) !== -1) {
            keys[UF_LENGTE_FORMAT_MAP[fk].toLowerCase()] = true;
          }
        }
      }
      var dims = ufDimsFromTitle(title);
      if (dims && isFinite(dims.l)) {
        var g2 = ufCmToGroepKey(dims.l, ranges);
        if (g2) keys[g2] = true;
      }
      return keys;
    }

    function ufBreedteGroepKeyFromTag(tag) {
      var m = String(tag || '').match(/plank breedte groep:\s*(.+)/i);
      return m ? m[1].trim().toLowerCase() : '';
    }

    function ufBreedteGroepKeysFromProduct(tags, title) {
      var keys = {};
      var ranges = window.__ufGroepRangesBreedte || [];
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufBreedteGroepKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      var cm = ufSpecCmFromTags(tags, 'breedte');
      if (isFinite(cm)) {
        var g = ufCmToGroepKey(cm, ranges);
        if (g) keys[g] = true;
      }
      var dims = ufDimsFromTitle(title);
      if (dims && isFinite(dims.w)) {
        var g2 = ufCmToGroepKey(dims.w, ranges);
        if (g2) keys[g2] = true;
      }
      return keys;
    }

    function ufDikteKeyFromTag(tag) {
      var raw = String(tag || '');
      var m = raw.match(/dikte totaal mm:\s*(.+)/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      m = raw.match(/dikte\s+in\s+mm:\s*(.+)/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      m = raw.match(/totale dikte\s*\(mm\):\s*([\d.,]+)/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      m = raw.match(/totale dikte:\s*([\d.,]+)\s*mm?/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      return '';
    }

    function ufProductgroepAndSoortFromTags(tags) {
      var pg = '';
      var soort = '';
      for (var i = 0; i < (tags || []).length; i++) {
        var raw = String(tags[i] || '');
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var val = raw.slice(c + 1).trim();
        if (head === 'productgroep' && val) pg = val.toLowerCase();
        if ((head === 'soort filter' || head === 'soort') && val) {
          soort = ufNormalizePvctypeValue(val);
        }
      }
      return { pg: pg, soort: soort };
    }

    function ufBuildProductgroepDikteHints(catalog) {
      var counts = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        var explicit = {};
        for (var ti = 0; ti < tags.length; ti++) {
          var dk = ufDikteKeyFromTag(tags[ti]);
          if (dk) explicit[dk] = true;
        }
        var dkKeys = Object.keys(explicit);
        if (dkKeys.length !== 1) continue;
        var ps = ufProductgroepAndSoortFromTags(tags);
        if (!ps.pg) continue;
        var token = ps.pg + '|' + ps.soort;
        if (!counts[token]) counts[token] = {};
        counts[token][dkKeys[0]] = (counts[token][dkKeys[0]] || 0) + 1;
      }
      var hints = {};
      for (var tok in counts) {
        if (!Object.prototype.hasOwnProperty.call(counts, tok)) continue;
        var best = '';
        var bestN = 0;
        for (var dk in counts[tok]) {
          if (counts[tok][dk] > bestN) {
            bestN = counts[tok][dk];
            best = dk;
          }
        }
        if (best) hints[tok] = best;
      }
      return hints;
    }

    function ufDikteKeysFromProduct(tags) {
      var keys = {};
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufDikteKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      if (Object.keys(keys).length) return keys;
      var ps = ufProductgroepAndSoortFromTags(tags);
      var hint =
        window.__ufProductgroepDikteHints && window.__ufProductgroepDikteHints[ps.pg + '|' + ps.soort];
      if (hint) keys[hint] = true;
      return keys;
    }

    function ufDikteKeyFromFilterTag(tag) {
      var k = ufDikteKeyFromTag(tag);
      if (k) return k;
      var m = String(tag || '').match(/dikte totaal mm:\s*(.+)/i);
      return m ? ufNormalizeMeasureNum(m[1]) : '';
    }

    function ufHoogteKeyFromTag(tag) {
      var raw = String(tag || '');
      var m = raw.match(/hoogte\s+in\s+mm:\s*(.+)/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      m = raw.match(/hoogte\s*\(mm\):\s*([\d.,]+)/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      m = raw.match(/(?:^|:\s*)hoogte:\s*([\d.,]+)\s*mm?/i);
      if (m) return ufNormalizeMeasureNum(m[1]);
      return '';
    }

    function ufHoogteKeysFromProduct(tags) {
      var keys = {};
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufHoogteKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      return keys;
    }

    function ufHoogteKeyFromFilterTag(tag) {
      return ufHoogteKeyFromTag(tag);
    }

    function ufCollectHoogteOptionsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var tag = tags[ti];
          var k = ufHoogteKeyFromTag(tag);
          if (!k) continue;
          if (!byKey[k]) byKey[k] = tag;
        }
      }
      var keys = Object.keys(byKey).sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
      var out = [];
      for (var i = 0; i < keys.length; i++) {
        out.push({ key: keys[i], tag: byKey[keys[i]], label: keys[i] + ' mm' });
      }
      return out;
    }

    function ufCollectDikteOptionsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var tag = tags[ti];
          var k = ufDikteKeyFromTag(tag);
          if (!k) continue;
          if (!byKey[k]) byKey[k] = tag;
        }
      }
      var keys = Object.keys(byKey).sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
      var out = [];
      for (var i = 0; i < keys.length; i++) {
        out.push({ key: keys[i], tag: byKey[keys[i]], label: keys[i] + ' mm' });
      }
      return out;
    }

    function ufSlijtlaagInferFromProductgroep(pg) {
      var p = String(pg || '').toLowerCase();
      if (!p) return '';
      if (/\b55\b/.test(p) || /55-70/.test(p)) return '0.55';
      if (/\b30\b/.test(p) && p.indexOf('55') === -1) return '0.3';
      return '';
    }

    function ufSlijtlaagKeysFromProduct(tags) {
      var keys = {};
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufSlijtlaagKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      if (Object.keys(keys).length) return keys;
      var ps = ufProductgroepAndSoortFromTags(tags);
      var inf = ufSlijtlaagInferFromProductgroep(ps.pg);
      if (inf) keys[inf] = true;
      return keys;
    }

    function ufWaterbestendigJaFromTags(tags) {
      for (var i = 0; i < (tags || []).length; i++) {
        var tl = String(tags[i] || '').toLowerCase();
        if (tl === 'waterbestendig: ja') return true;
        if (tl.indexOf('waterbestendig:') !== -1 && /:\s*ja\b/.test(tl)) return true;
        if (tl.indexOf('vochtwerend:') !== -1 && /:\s*ja\b/.test(tl)) return true;
      }
      return false;
    }

    function ufGeluidDbKeyFromTag(tag) {
      var raw = String(tag || '');
      if (raw.toLowerCase().indexOf('contactgeluidreductie') === -1) return '';
      var m = raw.match(/(\d+(?:[.,]\d+)?)\s*d?b/i);
      if (!m) return '';
      var n = parseInt(m[1], 10);
      return isFinite(n) ? String(n) : '';
    }

    function ufGeluidDbKeysFromProduct(tags) {
      var keys = {};
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufGeluidDbKeyFromTag(tags[i]);
        if (k) keys[k] = true;
      }
      return keys;
    }

    function ufOnderlaagKeyFromTag(tag) {
      var raw = String(tag || '');
      var tl = raw.toLowerCase();
      if (tl.indexOf('soort onderlaag:') !== -1) {
        return raw.split(':').pop().trim().toLowerCase();
      }
      // Match correct UTF-8, ASCII fallback, and legacy mojibake (GeÃ¯…) tags
      if (
        tl.indexOf('geïntegreerde ondervloer:') !== -1 ||
        tl.indexOf('geintegreerde ondervloer:') !== -1 ||
        tl.indexOf('ge\u00c3\u00afntegreerde ondervloer:') !== -1
      ) {
        var rest = raw.split(':').slice(1).join(':').trim().toLowerCase();
        if (rest.indexOf('nee') === 0) return 'nee';
        if (rest.indexOf('ja') === 0) {
          if (rest.indexOf('ixpe') !== -1) return 'ixpe';
          return 'ja';
        }
      }
      return '';
    }

    function ufOnderlaagKeysFromProduct(tags) {
      var keys = {};
      for (var i = 0; i < (tags || []).length; i++) {
        var k = ufOnderlaagKeyFromTag(tags[i]);
        if (!k) continue;
        keys[k] = true;
        if (k === 'ixpe') keys.ja = true;
      }
      return keys;
    }

    function ufOnderlaagKeyFromFilterTag(tag) {
      return ufOnderlaagKeyFromTag(tag) || String(tag || '').split(':').pop().trim().toLowerCase();
    }

    function ufInitFilterNormalizationCaches(rootEl, catalog) {
      window.__ufGroepRangesLengte = ufBuildGroepRangesFromFilter('lengte');
      window.__ufGroepRangesBreedte = ufBuildGroepRangesFromFilter('breedte');
      window.__ufProductgroepDikteHints = ufBuildProductgroepDikteHints(catalog || []);
    }

    function ufTagHandleizeShopify(str) {
      if (window.Shopify && typeof window.Shopify.handleize === 'function') {
        return window.Shopify.handleize(String(str || ''));
      }
      return String(str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    var UF_SORT_LOCALE = 'nl';

    /** Zichtbare filterlabeltekst zonder dynamische telling `(n)` â€” voor sorteren. */
    function ufFilterOptionLabelFromLi(li) {
      try {
        var lab = li.querySelector('.uf-check-label');
        if (!lab) return '';
        return String(lab.textContent || '')
          .replace(/\s*\(\d+\)\s*$/, '')
          .trim();
      } catch (eLab) {
        return '';
      }
    }

    /**
     * data-uf-sort="smart" = alfabetisch + numerieke volgorde waar er cijfers in het label staan (mm, groepen, â€¦).
     * data-uf-sort="alpha" = alleen alfabetisch. Geen attribuut / fixed = niet sorteren (bijv. Soort / lay-out volgorde).
     */
    function ufSortFilterUlByDataAttr(ul) {
      if (!ul) return;
      var mode = String(ul.getAttribute('data-uf-sort') || '').trim().toLowerCase();
      if (!mode || mode === 'none' || mode === 'fixed') return;
      var items = [];
      for (var ci = 0; ci < ul.children.length; ci++) {
        var n = ul.children[ci];
        if (n && n.nodeType === 1 && String(n.tagName).toUpperCase() === 'LI') items.push(n);
      }
      if (items.length < 2) return;
      var opts = mode === 'alpha' ? { sensitivity: 'base' } : { numeric: true, sensitivity: 'base' };
      items.sort(function (a, b) {
        return ufFilterOptionLabelFromLi(a).localeCompare(ufFilterOptionLabelFromLi(b), UF_SORT_LOCALE, opts);
      });
      for (var cj = 0; cj < items.length; cj++) ul.appendChild(items[cj]);
    }

    function ufSortAllMappedFilterLists(rootEl) {
      if (!rootEl || !rootEl.querySelectorAll) return;
      rootEl.querySelectorAll('ul[data-uf-sort]').forEach(function (ul) {
        ufSortFilterUlByDataAttr(ul);
      });
    }

    /** Verberg lege filterblokken (geen checkbox-opties). Toon weer na ufSync* (Merk op pagina 2+). */
    function ufHideEmptyFilterSections(rootEl) {
      if (!rootEl) return;
      rootEl.querySelectorAll('.single-cat').forEach(function (block) {
        if (block.id === 'uf-mapped-filters') return;
        block.hidden = !block.querySelector('.uf-filter-checkbox');
      });
      var tree = rootEl.querySelector('.uf-filter-pvc-tree');
      if (tree) tree.hidden = !tree.querySelector('.uf-filter-checkbox');
      ufSyncPlintenSubfilterVisibility(rootEl);
    }

    /** Generieke Assortiment/Soort-waarden (â‰ˆ Segment) â€” geen filteroptie op accessoires-collectie. */
    function ufAccessoiresGenericAssortimentKey(key) {
      var k = String(key || '').toLowerCase().trim();
      return k === 'accessoire' || k === 'accessoires';
    }

    function ufAccessoiresMeaningfulPvctypeTag(tag) {
      var key = ufPvctypeKeyFromTag(tag);
      return key && !ufAccessoiresGenericAssortimentKey(key);
    }

    /** Unieke Type-tags per genormaliseerde waarde; `Soort filter:` heeft voorrang op `Soort:`. */
    function ufCollectSoortFilterTagsFromCatalog(catalog, rootEl) {
      var isAccessoires = rootEl && rootEl.getAttribute('data-uf-accessoires') === 'true';
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          var key = ufPvctypeKeyFromTag(raw);
          if (!raw || !key) continue;
          if (isAccessoires && ufAccessoiresGenericAssortimentKey(key)) continue;
          var prev = byKey[key];
          var rawLow = String(raw).toLowerCase();
          var prefer =
            !prev ||
            (rawLow.indexOf('assortiment:') === 0 && String(prev).toLowerCase().indexOf('assortiment:') !== 0) ||
            (rawLow.indexOf('soort filter:') === 0 && String(prev).toLowerCase().indexOf('soort filter:') !== 0 && String(prev).toLowerCase().indexOf('assortiment:') !== 0) ||
            (rawLow.indexOf('pvctype:') === 0 && String(prev).toLowerCase().indexOf('pvctype:') !== 0 && String(prev).toLowerCase().indexOf('assortiment:') !== 0 && String(prev).toLowerCase().indexOf('soort filter:') !== 0);
          if (prefer) {
            byKey[key] = raw;
          }
        }
      }
      var out = [];
      for (var bk in byKey) {
        if (!Object.prototype.hasOwnProperty.call(byKey, bk)) continue;
        if (!ufIsAllowedPvctypeKey(bk, rootEl)) continue;
        out.push(byKey[bk]);
      }
      if (isAccessoires) {
        var hasSchoonmaak = false;
        for (var spi = 0; spi < (catalog || []).length; spi++) {
          if (ufAccessoiresHasSchoonmaakAccsoort((catalog[spi] && catalog[spi].tags) || [])) {
            hasSchoonmaak = true;
            break;
          }
        }
        if (hasSchoonmaak && !byKey.schoonmaakspullen) {
          out.push(UF_ACCESSOIRES_SCHOONMAAK_TAG);
        }
      }
      if (ufIsStandardPvctypeFilterContext(rootEl)) {
        out.sort(function (a, b) {
          var ia = UF_PVCTYPE_FILTER_KEYS.indexOf(ufPvctypeKeyFromTag(a));
          var ib = UF_PVCTYPE_FILTER_KEYS.indexOf(ufPvctypeKeyFromTag(b));
          return ia - ib;
        });
      } else {
        out.sort(function (a, b) {
          return ufPvctypeLabelFromTag(a).localeCompare(ufPvctypeLabelFromTag(b), UF_SORT_LOCALE, {
            numeric: true,
            sensitivity: 'base'
          });
        });
      }
      return out;
    }

    function ufAssortimentLabelFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      return c === -1 ? raw.trim() : raw.slice(c + 1).trim();
    }

    function ufAssortimentKeyFromTag(tag) {
      return ufAssortimentLabelFromTag(tag).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function ufProductgroepLabelFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      return c === -1 ? raw.trim() : raw.slice(c + 1).trim();
    }

    function ufProductgroepKeyFromTag(tag) {
      return ufProductgroepLabelFromTag(tag).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function ufAccsoortLabelFromTag(tag) {
      var raw = String(tag || '');
      var marker = 'specificatie: soort:';
      var idx = raw.toLowerCase().indexOf(marker);
      if (idx === -1) return '';
      return raw.slice(idx + marker.length).trim();
    }

    function ufAccsoortKeyFromTag(tag) {
      return ufAccsoortLabelFromTag(tag).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function ufCollectAccsoortTagsFromCatalog(catalog) {
      var seen = {};
      var out = [];
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          var key = ufAccsoortKeyFromTag(raw);
          if (!key || seen[key]) continue;
          seen[key] = true;
          out.push(raw);
        }
      }
      out.sort(function (a, b) {
        return ufAccsoortLabelFromTag(a).localeCompare(ufAccsoortLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufCollectProductgroepTagsFromCatalog(catalog) {
      var seen = {};
      var out = [];
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          if (!raw) continue;
          var c = raw.indexOf(':');
          if (c === -1) continue;
          var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
          if (head !== 'productgroep') continue;
          var key = ufProductgroepKeyFromTag(raw);
          if (!key || seen[key]) continue;
          seen[key] = true;
          out.push(raw);
        }
      }
      out.sort(function (a, b) {
        return ufProductgroepLabelFromTag(a).localeCompare(ufProductgroepLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufCollectAssortimentTagsFromCatalog(catalog) {
      var seen = {};
      var out = [];
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          if (!raw) continue;
          var c = raw.indexOf(':');
          if (c === -1) continue;
          var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
          if (head !== 'assortiment') continue;
          if (!ufAssortimentLabelFromTag(raw)) continue;
          if (ufAccessoiresGenericAssortimentKey(ufAssortimentKeyFromTag(raw))) continue;
          if (seen[raw]) continue;
          seen[raw] = true;
          out.push(raw);
        }
      }
      out.sort(function (a, b) {
        return ufAssortimentLabelFromTag(a).localeCompare(ufAssortimentLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufSyncPlintenProductgroepFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var ul = rootEl.querySelector('#uf-productgroep-filter-list');
      if (!ul) return;
      var fromCat = ufCollectProductgroepTagsFromCatalog(catalog).filter(function (tag) {
        var key = ufProductgroepKeyFromTag(tag);
        return key && !ufIsPlintenCategorySoortKey(key);
      });
      if (!fromCat.length) return;
      var existing = {};
      ul.querySelectorAll('input[data-group="productgroep"]').forEach(function (inp) {
        var k = ufProductgroepKeyFromTag(inp.getAttribute('data-tag'));
        if (k) existing[k] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var key = ufProductgroepKeyFromTag(tag);
        if (!key || existing[key]) continue;
        existing[key] = true;
        ufAppendMappedFilterOption(ul, 'productgroep', tag, ufProductgroepLabelFromTag(tag));
      }
    }

    function ufPlinthoofdsoortKeyFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      return (c === -1 ? raw : raw.slice(c + 1)).trim().toLowerCase();
    }

    function ufPlinthoofdsoortKeysFromProduct(tags, title, handle, productType) {
      var keys = {};
      if (ufProductIsPlintItem(tags, title, handle, productType)) keys.plint = true;
      var ptKey = ufProfieltypeKeyFromProduct(title, tags, handle);
      if (ptKey === 'trapprofiel') keys.trapprofiel = true;
      else if (ufProductIsProfielItem(tags, title, handle)) keys.profiel = true;
      return keys;
    }

    function tileMatchesPlinthoofdsoort(tileTags, selectedTags, title, handle, productType) {
      if (!selectedTags || selectedTags.length === 0) return true;
      var have = ufPlinthoofdsoortKeysFromProduct(tileTags, title, handle, productType);
      for (var i = 0; i < selectedTags.length; i++) {
        var k = ufPlinthoofdsoortKeyFromTag(selectedTags[i]);
        if (k && have[k]) return true;
      }
      return false;
    }

    function ufSyncProductgroepFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-traprenovatie') !== 'true') return;
      var ul = rootEl.querySelector('#uf-pvctype-filter-list');
      if (!ul) return;
      var fromCat = ufCollectProductgroepTagsFromCatalog(catalog);
      var existing = {};
      ul.querySelectorAll('input[data-group="productgroep"]').forEach(function (inp) {
        var dt = inp.getAttribute('data-tag');
        var k = ufProductgroepKeyFromTag(dt);
        if (k) existing[k] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var key = ufProductgroepKeyFromTag(tag);
        if (!key || existing[key]) continue;
        existing[key] = true;
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'productgroep');
        inp.setAttribute('data-tag', tag);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
        var ui = document.createElement('span');
        ui.className = 'uf-check-ui';
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = ufProductgroepLabelFromTag(tag);
        lab.appendChild(inp);
        lab.appendChild(ui);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    function ufSyncAssortimentFilterOptions(rootEl, catalog) {
      ufSyncProductgroepFilterOptions(rootEl, catalog);
    }

    function ufSyncAccsoortFilterOptions(rootEl, catalog) {
      return;
    }

    /** Verwijdert niet-toegestane Type-opties (PVC: alleen Click, Loose lay, Plak). */
    function ufPrunePvctypeFilterList(rootEl) {
      if (!rootEl || !ufIsStandardPvctypeFilterContext(rootEl)) return;
      var ul = rootEl.querySelector('#uf-pvctype-filter-list');
      if (!ul) return;
      ul.querySelectorAll('input[data-group="pvctype"]').forEach(function (inp) {
        var key = ufPvctypeKeyFromTag(inp.getAttribute('data-tag'));
        if (ufIsAllowedPvctypeKey(key, rootEl)) return;
        var li = inp.closest('li');
        if (li) li.remove();
      });
    }

    /** Vult Type-filter aan met tags uit de volledige collectie-JSON (niet alleen collection.all_tags). */
    function ufSyncPvctypeFilterOptions(rootEl, catalog) {
      if (rootEl && rootEl.getAttribute('data-uf-traprenovatie') === 'true') return;
      var ul = rootEl.querySelector('#uf-pvctype-filter-list');
      if (!ul) return;
      ufPrunePvctypeFilterList(rootEl);
      var fromCat = ufCollectSoortFilterTagsFromCatalog(catalog, rootEl);
      var existing = {};
      ul.querySelectorAll('input[data-group="pvctype"]').forEach(function (inp) {
        var dt = inp.getAttribute('data-tag');
        var k = ufPvctypeKeyFromTag(dt);
        if (k) existing[k] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var key = ufPvctypeKeyFromTag(tag);
        if (!key || existing[key]) continue;
        if (!ufIsAllowedPvctypeKey(key, rootEl)) continue;
        if (key === 'profielen' && rootEl && rootEl.getAttribute('data-uf-plinten') === 'true') continue;
        existing[key] = true;
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'pvctype');
        inp.setAttribute('data-tag', tag);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
        var ui = document.createElement('span');
        ui.className = 'uf-check-ui';
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = ufPvctypeLabelFromTag(tag);
        lab.appendChild(inp);
        lab.appendChild(ui);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    function ufIsMerkColonTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      if (c === -1) return false;
      var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
      return head === 'merk';
    }

    function ufMerkLabelFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      return c === -1 ? raw.trim() : raw.slice(c + 1).trim();
    }

    function ufMerkTagFromVendor(vendor) {
      var label = String(vendor || '').trim();
      if (!label) return '';
      return 'Merk: ' + label;
    }

    function ufMerkKeysFromProduct(tileTags, vendor, title) {
      var keys = {};
      for (var j = 0; j < (tileTags || []).length; j++) {
        var raw = tileTags[j];
        if (!ufIsMerkColonTag(raw)) continue;
        var lk = ufMerkLabelFromTag(raw).toLowerCase();
        if (lk) keys[lk] = true;
      }
      var vk = ufMerkLabelFromTag(ufMerkTagFromVendor(vendor)).toLowerCase();
      if (vk) keys[vk] = true;
      var tl = String(title || '').toLowerCase();
      if (tl.indexOf('tarkett') !== -1) keys.tarkett = true;
      if (tl.indexOf('ambiant') !== -1) keys.ambiant = true;
      if (tl.indexOf('belakos') !== -1) keys.belakos = true;
      if (tl.indexOf('ppc ') === 0 || tl.indexOf('ppc ') !== -1) keys.ppc = true;
      return keys;
    }

    function ufIsPlintenProfielProduct(tileTags, title, productType) {
      var t = String(title || '').toLowerCase();
      var pt = String(productType || '').toLowerCase();
      if (t.indexOf('trapprofiel') !== -1) return true;
      if (pt.indexOf('plint') !== -1 || pt.indexOf('profiel') !== -1) return true;
      for (var i = 0; i < (tileTags || []).length; i++) {
        var raw = String(tileTags[i] || '').trim();
        var tl = raw.toLowerCase();
        if (tl === 'segment: plint' || tl === 'segment: plinten' || tl === 'plinten' || tl === 'plint') return true;
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var val = raw.slice(c + 1).trim().toLowerCase();
        if (head === 'soort filter' || head === 'productgroep' || head === 'assortiment') {
          if (val.indexOf('plint') !== -1 || val.indexOf('profiel') !== -1) return true;
        }
      }
      return false;
    }

    function ufMerkDisplayFromProduct(tileTags, title, productType) {
      if (ufIsPlintenProfielProduct(tileTags, title, productType)) return '';
      var knownTags = {
        'merk: ambiant': 'Ambiant',
        'merk: belakos': 'Belakos',
        'merk: tarkett': 'Tarkett',
        'merk: ppc': 'PPC'
      };
      for (var j = 0; j < (tileTags || []).length; j++) {
        var raw = String(tileTags[j] || '').trim().toLowerCase();
        if (knownTags[raw]) return knownTags[raw];
      }
      for (var k = 0; k < (tileTags || []).length; k++) {
        var raw2 = tileTags[k];
        if (!ufIsMerkColonTag(raw2)) continue;
        var lk = ufMerkLabelFromTag(raw2).toLowerCase();
        if (lk === 'ambiant') return 'Ambiant';
        if (lk === 'belakos') return 'Belakos';
        if (lk === 'tarkett') return 'Tarkett';
        if (lk === 'ppc') return 'PPC';
        var generic = ufMerkLabelFromTag(raw2);
        if (generic) return generic;
      }
      var tl = String(title || '').toLowerCase();
      if (tl.indexOf('tarkett') !== -1) return 'Tarkett';
      if (tl.indexOf('ambiant') !== -1) return 'Ambiant';
      if (tl.indexOf('belakos') !== -1) return 'Belakos';
      if (tl.indexOf('ppc ') === 0 || tl.indexOf('ppc ') !== -1) return 'PPC';
      return '';
    }

    function ufCollectMerkTagsFromCatalog(catalog) {
      var byLabel = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var prod = catalog[pi];
        var tags = prod.tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          if (!raw || !ufIsMerkColonTag(raw)) continue;
          var labelKey = ufMerkLabelFromTag(raw).toLowerCase();
          if (!labelKey) continue;
          var prev = byLabel[labelKey];
          if (!prev || (ufIsMerkColonTag(raw) && !ufIsMerkColonTag(prev))) {
            byLabel[labelKey] = raw;
          }
        }
        var fromVendor = ufMerkTagFromVendor(prod.vendor);
        if (fromVendor) {
          var vk = ufMerkLabelFromTag(fromVendor).toLowerCase();
          if (vk && !byLabel[vk]) byLabel[vk] = fromVendor;
        }
      }
      var out = [];
      for (var mk in byLabel) {
        if (Object.prototype.hasOwnProperty.call(byLabel, mk)) out.push(byLabel[mk]);
      }
      out.sort(function (a, b) {
        return ufMerkLabelFromTag(a).localeCompare(ufMerkLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufKleurGroepLabelFromTag(tag) {
      var raw = String(tag || '');
      var c = raw.toLowerCase().indexOf('kleur groep:');
      if (c === -1) return '';
      return raw.slice(raw.toLowerCase().indexOf('kleur groep:') + 'kleur groep:'.length).trim();
    }

    function ufCollectKleurGroepTagsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var label = ufKleurGroepLabelFromTag(tags[ti]);
          if (!label) continue;
          var key = label.toLowerCase().replace(/\s+/g, ' ');
          if (!byKey[key]) byKey[key] = tags[ti];
        }
      }
      var out = [];
      Object.keys(byKey)
        .sort(function (a, b) {
          return a.localeCompare(b, UF_SORT_LOCALE, { sensitivity: 'base' });
        })
        .forEach(function (k) {
          out.push(byKey[k]);
        });
      return out;
    }

    /** Shopify collection.all_tags is incompleet bij veel unieke tags (o.a. Kleurrijk). */
    function ufSyncKleurGroepFilterOptions(rootEl, catalog) {
      var ul = rootEl.querySelector('.uf-kleur-panel--groep ul');
      if (!ul) return;
      var existing = {};
      ul.querySelectorAll('input[data-group="kleur"]').forEach(function (inp) {
        var label = ufKleurGroepLabelFromTag(inp.getAttribute('data-tag')).toLowerCase();
        if (label) existing[label] = true;
      });
      var fromCat = ufCollectKleurGroepTagsFromCatalog(catalog);
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var label = ufKleurGroepLabelFromTag(tag);
        var key = label.toLowerCase();
        if (!key || existing[key]) continue;
        existing[key] = true;
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check uf-check--kleur-thumb';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'kleur');
        inp.setAttribute('data-tag', tag);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
        var thumb = document.createElement('span');
        thumb.className = 'uf-kleur-filter-thumb';
        thumb.setAttribute('aria-hidden', 'true');
        var ph = document.createElement('span');
        ph.className = 'uf-kleur-filter-thumb__ph';
        thumb.appendChild(ph);
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = label;
        lab.appendChild(inp);
        lab.appendChild(thumb);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    function ufSyncMerkFilterOptions(rootEl, catalog) {
      var ul = rootEl.querySelector('#uf-merk-filter-list');
      if (!ul) return;
      var fromCat = ufCollectMerkTagsFromCatalog(catalog);
      var existing = {};
      ul.querySelectorAll('input[data-group="merk"]').forEach(function (inp) {
        var dt = inp.getAttribute('data-tag');
        var lk = ufMerkLabelFromTag(dt).toLowerCase();
        if (lk) existing[lk] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var labelKey = ufMerkLabelFromTag(tag).toLowerCase();
        if (!labelKey || existing[labelKey]) continue;
        existing[labelKey] = true;
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'merk');
        inp.setAttribute('data-tag', tag);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
        var ui = document.createElement('span');
        ui.className = 'uf-check-ui';
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = ufMerkLabelFromTag(tag);
        lab.appendChild(inp);
        lab.appendChild(ui);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    function ufCollectGeluidOptionsFromCatalog(catalog) {
      var byDb = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var tags = catalog[pi].tags || [];
        for (var ti = 0; ti < tags.length; ti++) {
          var raw = tags[ti];
          var db = ufGeluidDbKeyFromTag(raw);
          if (!db) continue;
          if (!byDb[db]) byDb[db] = {};
          byDb[db][raw] = true;
        }
      }
      var dbs = Object.keys(byDb).sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      return dbs.map(function (db) {
        var tagList = Object.keys(byDb[db]);
        tagList.sort();
        var primary = tagList[0];
        for (var i = 0; i < tagList.length; i++) {
          if (tagList[i].toLowerCase().indexOf('contactgeluidreductie db:') !== -1) {
            primary = tagList[i];
            break;
          }
        }
        return { db: db, primary: primary, orTags: tagList };
      });
    }

    function ufSyncGeluidFilterOptions(rootEl, catalog) {
      var ul = rootEl.querySelector('#uf-collapse-geluid ul');
      if (!ul) return;
      var opts = ufCollectGeluidOptionsFromCatalog(catalog);
      if (!opts.length) return;
      var existing = {};
      ul.querySelectorAll('input[data-group="geluid"]').forEach(function (inp) {
        var db = ufGeluidDbKeyFromTag(inp.getAttribute('data-tag'));
        if (db) existing[db] = true;
      });
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (existing[o.db]) continue;
        existing[o.db] = true;
        var li = document.createElement('li');
        var lab = document.createElement('label');
        lab.className = 'uf-check';
        var inp = document.createElement('input');
        inp.type = 'checkbox';
        inp.className = 'uf-filter-checkbox';
        inp.setAttribute('data-group', 'geluid');
        inp.setAttribute('data-tag', o.primary);
        inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(o.primary));
        inp.setAttribute('data-uf-geluid-or', o.orTags.join('|||'));
        var ui = document.createElement('span');
        ui.className = 'uf-check-ui';
        var cap = document.createElement('span');
        cap.className = 'uf-check-label';
        cap.textContent = o.db + ' dB gecertificeerd';
        lab.appendChild(inp);
        lab.appendChild(ui);
        lab.appendChild(cap);
        li.appendChild(lab);
        ul.appendChild(li);
      }
    }

    function ufSyncOnderlaagFilterOptions(rootEl, catalog) {
      var ul = rootEl.querySelector('#uf-collapse-ondervloer ul');
      if (!ul) return;
      var needNee = false;
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var keys = ufOnderlaagKeysFromProduct(catalog[pi].tags || []);
        if (keys.nee) {
          needNee = true;
          break;
        }
      }
      if (!needNee) return;
      var neeTag = 'Specificatie: Geïntegreerde ondervloer: Nee';
      var hasNee = false;
      ul.querySelectorAll('input[data-group="onderlaag"]').forEach(function (inp) {
        if (ufOnderlaagKeyFromFilterTag(inp.getAttribute('data-tag')) === 'nee') hasNee = true;
      });
      if (hasNee) return;
      var li = document.createElement('li');
      var lab = document.createElement('label');
      lab.className = 'uf-check';
      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.className = 'uf-filter-checkbox';
      inp.setAttribute('data-group', 'onderlaag');
      inp.setAttribute('data-tag', neeTag);
      inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(neeTag));
      var ui = document.createElement('span');
      ui.className = 'uf-check-ui';
      var cap = document.createElement('span');
      cap.className = 'uf-check-label';
      cap.textContent = 'Nee';
      lab.appendChild(inp);
      lab.appendChild(ui);
      lab.appendChild(cap);
      li.appendChild(lab);
      ul.appendChild(li);
    }

    function tileMatchesPvctype(tileTags, selectedPvctypeTags) {
      if (!selectedPvctypeTags || selectedPvctypeTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedPvctypeTags.length; i++) {
        var k = ufPvctypeKeyFromTag(selectedPvctypeTags[i]);
        if (k) want[k] = true;
      }
      var have = ufPvctypeKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesMerk(tileTags, selectedMerkTags, vendor, title) {
      if (!selectedMerkTags || selectedMerkTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedMerkTags.length; i++) {
        var k = ufMerkLabelFromTag(selectedMerkTags[i]).toLowerCase();
        if (k) want[k] = true;
      }
      var have = ufMerkKeysFromProduct(tileTags, vendor, title);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesAssortiment(tileTags, selectedAssortimentTags) {
      if (!selectedAssortimentTags || selectedAssortimentTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedAssortimentTags.length; i++) {
        var k = ufAssortimentKeyFromTag(selectedAssortimentTags[i]);
        if (k) want[k] = true;
      }
      for (var j = 0; j < (tileTags || []).length; j++) {
        var raw = tileTags[j];
        if (!raw) continue;
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        if (head !== 'assortiment') continue;
        var hk = ufAssortimentKeyFromTag(raw);
        if (hk && want[hk]) return true;
      }
      return false;
    }

    function ufProductgroepKeysFromProduct(tileTags) {
      var keys = {};
      for (var j = 0; j < (tileTags || []).length; j++) {
        var raw = tileTags[j];
        if (!raw) continue;
        var down = String(raw).toLowerCase().trim();
        if (down === 'profielen') keys.profielen = true;
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        if (head !== 'productgroep') continue;
        var hk = ufProductgroepKeyFromTag(raw);
        if (hk) keys[hk] = true;
      }
      return keys;
    }

    function tileMatchesProductgroep(tileTags, selectedProductgroepTags) {
      if (!selectedProductgroepTags || selectedProductgroepTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedProductgroepTags.length; i++) {
        var k = ufProductgroepKeyFromTag(selectedProductgroepTags[i]);
        if (k) want[k] = true;
      }
      var have = ufProductgroepKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesAccsoort(tileTags, selectedAccsoortTags) {
      if (!selectedAccsoortTags || selectedAccsoortTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedAccsoortTags.length; i++) {
        var k = ufAccsoortKeyFromTag(selectedAccsoortTags[i]);
        if (k) want[k] = true;
      }
      for (var j = 0; j < (tileTags || []).length; j++) {
        var hk = ufAccsoortKeyFromTag(tileTags[j]);
        if (hk && want[hk]) return true;
      }
      return false;
    }

    function tileMatchesKleurGroup(tileTags, selectedKleurTags) {
      if (!selectedKleurTags || selectedKleurTags.length === 0) return true;
      var want = {};
      var wantRal = {};
      for (var i = 0; i < selectedKleurTags.length; i++) {
        var sel = selectedKleurTags[i];
        var k = ufFilterSelectionKey('kleur', sel);
        if (k) want[k] = true;
        var ralM = String(sel || '').match(/RAL\s*(\d+)/i);
        if (ralM) wantRal[ralM[1]] = true;
      }
      for (var j = 0; j < (tileTags || []).length; j++) {
        var tileTag = tileTags[j];
        var tk = ufFilterSelectionKey('kleur', tileTag);
        if (tk && want[tk]) return true;
        var tileRal = String(tileTag || '').match(/RAL\s*(\d+)/i);
        if (tileRal && wantRal[tileRal[1]]) return true;
      }
      return false;
    }

    function tileMatchesVgroeven(tileTags, selectedVgroevenTags) {
      if (!selectedVgroevenTags || selectedVgroevenTags.length === 0) return true;
      var keys = {};
      for (var i = 0; i < selectedVgroevenTags.length; i++) {
        var k = ufVgroevenKeyFromTag(selectedVgroevenTags[i]);
        if (k) keys[k] = true;
      }
      for (var j = 0; j < tileTags.length; j++) {
        var tk = ufVgroevenKeyFromTag(tileTags[j]);
        if (tk && keys[tk]) return true;
      }
      return false;
    }

    function tileMatchesSlijtlaag(tileTags, selectedSlijtlaagTags) {
      if (!selectedSlijtlaagTags || selectedSlijtlaagTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedSlijtlaagTags.length; i++) {
        var k = ufSlijtlaagKeyFromTag(selectedSlijtlaagTags[i]);
        if (k) want[k] = true;
      }
      var have = ufSlijtlaagKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesLengte(tileTags, selectedLengteTags, title) {
      if (!selectedLengteTags || selectedLengteTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedLengteTags.length; i++) {
        var k = ufLengteGroepKeyFromTag(selectedLengteTags[i]);
        if (k) want[k] = true;
      }
      var have = ufLengteGroepKeysFromProduct(tileTags, title);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesBreedte(tileTags, selectedBreedteTags, title) {
      if (!selectedBreedteTags || selectedBreedteTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedBreedteTags.length; i++) {
        var k = ufBreedteGroepKeyFromTag(selectedBreedteTags[i]);
        if (k) want[k] = true;
      }
      var have = ufBreedteGroepKeysFromProduct(tileTags, title);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesDikte(tileTags, selectedDikteTags) {
      if (!selectedDikteTags || selectedDikteTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedDikteTags.length; i++) {
        var k = ufDikteKeyFromFilterTag(selectedDikteTags[i]);
        if (k) want[k] = true;
      }
      var have = ufDikteKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesHoogte(tileTags, selectedHoogteTags) {
      if (!selectedHoogteTags || selectedHoogteTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedHoogteTags.length; i++) {
        var k = ufHoogteKeyFromFilterTag(selectedHoogteTags[i]);
        if (k) want[k] = true;
      }
      var have = ufHoogteKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesOnderlaag(tileTags, selectedOnderlaagTags) {
      if (!selectedOnderlaagTags || selectedOnderlaagTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedOnderlaagTags.length; i++) {
        var k = ufOnderlaagKeyFromFilterTag(selectedOnderlaagTags[i]);
        if (k) want[k] = true;
      }
      var have = ufOnderlaagKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    function tileMatchesWaterbestendig(tileTags, selectedWaterTags) {
      if (!selectedWaterTags || selectedWaterTags.length === 0) return true;
      return ufWaterbestendigJaFromTags(tileTags);
    }

    function tileMatchesGeluid(tileTags, selectedGeluidTags) {
      if (!selectedGeluidTags || selectedGeluidTags.length === 0) return true;
      var want = {};
      for (var i = 0; i < selectedGeluidTags.length; i++) {
        var k = ufGeluidDbKeyFromTag(selectedGeluidTags[i]);
        if (k) want[k] = true;
      }
      var have = ufGeluidDbKeysFromProduct(tileTags);
      for (var wk in want) {
        if (Object.prototype.hasOwnProperty.call(want, wk) && have[wk]) return true;
      }
      return false;
    }

    /** Vloerverwarming: `Vloerverwarming geschikt: Ja` of Tarkett-specificatie-tag. */
    function ufVloerverwarmingGeschiktFromTags(tileTags) {
      for (var i = 0; i < (tileTags || []).length; i++) {
        var raw = String(tileTags[i] || '');
        var tl = raw.toLowerCase();
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var rest = raw.slice(c + 1).trim().toLowerCase();
        if (head === 'vloerverwarming geschikt' && rest === 'ja') return true;
        if (head === 'specificatie' && tl.indexOf('geschikt voor vloerverwarming') !== -1 && rest.indexOf('geschikt') !== -1) return true;
      }
      return false;
    }

    function tileMatchesVftype(tileTags, selectedVftypeTags) {
      if (!selectedVftypeTags || selectedVftypeTags.length === 0) return true;
      return ufVloerverwarmingGeschiktFromTags(tileTags);
    }

    function ufProfieltypeKeyFromProduct(title, tags, handle) {
      var t = String(title || '').toLowerCase();
      var h = String(handle || '').toLowerCase();
      if (t.indexOf('trapprofiel') !== -1 || h.indexOf('trapprofiel') !== -1) return 'trapprofiel';
      for (var i = 0; i < (tags || []).length; i++) {
        if (String(tags[i] || '').toLowerCase().indexOf('trapprofiel') !== -1) return 'trapprofiel';
      }
      if (t.indexOf('dilatatie') !== -1) return 'dilatatieprofiel';
      if (t.indexOf('hoek') !== -1 || t.indexOf('eindstuk') !== -1) return 'hoek-eindstuk';
      return '';
    }

    function ufProfieltypeKeyFromNavTag(tag) {
      var raw = String(tag || '');
      var c = raw.indexOf(':');
      if (c === -1) return raw.trim().toLowerCase();
      var head = raw.slice(0, c).trim().toLowerCase();
      if (head !== 'profieltype') return '';
      return raw.slice(c + 1).trim().toLowerCase().replace(/\s+/g, '-');
    }

    var UF_PLINTEN_CATEGORY_SOORT_KEYS = { plint: true, profielen: true };
    var UF_PROFIELTYPE_LABELS = {
      trapprofiel: 'Trapprofiel',
      'hoek-eindstuk': 'Hoek- en eindstukken',
      dilatatieprofiel: 'Dilatatieprofiel'
    };

    function ufIsPlintenCategorySoortKey(key) {
      return !!UF_PLINTEN_CATEGORY_SOORT_KEYS[String(key || '').toLowerCase().trim()];
    }

    function ufSpecificatieSoortValueFromTag(tag) {
      var raw = String(tag || '');
      if (raw.toLowerCase().indexOf('specificatie:') !== 0) return '';
      var idx = raw.toLowerCase().indexOf('soort:');
      if (idx === -1) return '';
      return raw.slice(idx + 6).trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function ufSpecificatieSoortLabelFromTag(tag) {
      var raw = String(tag || '');
      var idx = raw.toLowerCase().indexOf('soort:');
      if (idx === -1) return '';
      return raw.slice(idx + 6).trim();
    }

    function ufProductIsProfielItem(tags, title, handle) {
      if (ufProfieltypeKeyFromProduct(title, tags, handle)) return true;
      var pvc = ufPvctypeKeysFromProduct(tags);
      if (pvc.profielen || pvc.randafwerking) return true;
      var pg = ufProductgroepKeysFromProduct(tags);
      if (pg.profielen) return true;
      for (var i = 0; i < (tags || []).length; i++) {
        var raw = String(tags[i] || '');
        var tl = raw.toLowerCase();
        if (tl.indexOf('assortiment:') === 0 && tl.indexOf('profiel') !== -1) return true;
        var ss = ufSpecificatieSoortValueFromTag(raw);
        if (ss && ss !== 'plint') return true;
      }
      return false;
    }

    function ufProductIsPlintItem(tags, title, handle, productType) {
      if (ufProductIsProfielItem(tags, title, handle)) return false;
      var pg = ufProductgroepKeysFromProduct(tags);
      if (pg.plint) return true;
      for (var si = 0; si < (tags || []).length; si++) {
        if (ufSpecificatieSoortValueFromTag(tags[si]) === 'plint') return true;
      }
      var pt = String(productType || '').toLowerCase();
      if (pt.indexOf('plint') !== -1 && pt.indexOf('profiel') === -1) return true;
      for (var i = 0; i < (tags || []).length; i++) {
        var raw = String(tags[i] || '');
        var tl = raw.toLowerCase();
        if (tl === 'segment: plint' || tl === 'segment: plinten') return true;
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var val = raw.slice(c + 1).trim().toLowerCase();
        if (head === 'productgroep' && val.indexOf('plint') !== -1) return true;
      }
      return false;
    }

    function ufPlintsoortLabelFromTag(tag) {
      var raw = String(tag || '');
      if (raw.toLowerCase().indexOf('plintsoort:') === 0) {
        return raw.slice(raw.indexOf(':') + 1).trim();
      }
      return ufPvctypeLabelFromTag(raw) || ufProductgroepLabelFromTag(raw);
    }

    function ufPlintsoortKeyFromTag(tag) {
      return ufPlintsoortLabelFromTag(tag).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function ufProfielsoortLabelFromTag(tag) {
      var raw = String(tag || '');
      if (raw.toLowerCase().indexOf('profielsoort:') === 0) {
        return raw.slice(raw.indexOf(':') + 1).trim();
      }
      return ufProductgroepLabelFromTag(raw) || ufSpecificatieSoortLabelFromTag(raw);
    }

    function ufProfielsoortKeyFromTag(tag) {
      return ufProfielsoortLabelFromTag(tag).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function ufProfielsoortTagFromProfieltypeNav(navTag) {
      var k = ufProfieltypeKeyFromNavTag(navTag);
      if (k && UF_PROFIELTYPE_LABELS[k]) return 'profielsoort: ' + UF_PROFIELTYPE_LABELS[k];
      return '';
    }

    function ufPlintsoortEntriesFromProduct(tags, title, handle, productType) {
      if (!ufProductIsPlintItem(tags, title, handle, productType)) return [];
      var byKey = {};
      function add(label) {
        var key = String(label || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (!key || ufIsPlintenCategorySoortKey(key) || key === 'profielen') return;
        if (byKey[key]) return;
        byKey[key] = { key: key, label: String(label).trim(), tag: 'plintsoort: ' + String(label).trim() };
      }
      for (var i = 0; i < (tags || []).length; i++) {
        var raw = tags[i];
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var val = raw.slice(c + 1).trim();
        if (head === 'soort filter' || head === 'soort' || head === 'pvctype') {
          var pk = ufPvctypeKeyFromTag(raw);
          if (pk && pk !== 'profielen') add(ufPvctypeLabelFromTag(raw));
        }
      }
      return Object.keys(byKey).map(function (k) {
        return byKey[k];
      });
    }

    function ufProfielsoortEntriesFromProduct(tags, title, handle) {
      if (!ufProductIsProfielItem(tags, title, handle)) return [];
      var byKey = {};
      function add(label) {
        var key = String(label || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (!key || ufIsPlintenCategorySoortKey(key)) return;
        if (byKey[key]) return;
        byKey[key] = { key: key, label: String(label).trim(), tag: 'profielsoort: ' + String(label).trim() };
      }
      var pt = ufProfieltypeKeyFromProduct(title, tags, handle);
      if (pt && UF_PROFIELTYPE_LABELS[pt]) add(UF_PROFIELTYPE_LABELS[pt]);
      for (var i = 0; i < (tags || []).length; i++) {
        var raw = tags[i];
        var c = raw.indexOf(':');
        if (c === -1) continue;
        var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, ' ');
        var val = raw.slice(c + 1).trim();
        if (head === 'productgroep' && !ufIsPlintenCategorySoortKey(val.toLowerCase())) add(val);
        if (head === 'specificatie') {
          var ss = ufSpecificatieSoortValueFromTag(raw);
          if (ss && ss !== 'plint') add(ufSpecificatieSoortLabelFromTag(raw));
        }
      }
      return Object.keys(byKey).map(function (k) {
        return byKey[k];
      });
    }

    function ufPlintsoortKeysFromProduct(tags, title, handle, productType) {
      var keys = {};
      ufPlintsoortEntriesFromProduct(tags, title, handle, productType).forEach(function (e) {
        keys[e.key] = true;
      });
      return keys;
    }

    function ufProfielsoortKeysFromProduct(tags, title, handle) {
      var keys = {};
      ufProfielsoortEntriesFromProduct(tags, title, handle).forEach(function (e) {
        keys[e.key] = true;
      });
      return keys;
    }

    function ufCollectPlintsoortTagsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var prod = catalog[pi];
        ufPlintsoortEntriesFromProduct(prod.tags || [], prod.title || '', prod.handle || '', prod.product_type || '').forEach(
          function (e) {
            if (!byKey[e.key]) byKey[e.key] = e.tag;
          }
        );
      }
      var out = [];
      for (var bk in byKey) {
        if (Object.prototype.hasOwnProperty.call(byKey, bk)) out.push(byKey[bk]);
      }
      out.sort(function (a, b) {
        return ufPlintsoortLabelFromTag(a).localeCompare(ufPlintsoortLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufCollectProfielsoortTagsFromCatalog(catalog) {
      var byKey = {};
      for (var pi = 0; pi < (catalog || []).length; pi++) {
        var prod = catalog[pi];
        ufProfielsoortEntriesFromProduct(prod.tags || [], prod.title || '', prod.handle || '').forEach(function (e) {
          if (!byKey[e.key]) byKey[e.key] = e.tag;
        });
      }
      var out = [];
      for (var bk in byKey) {
        if (Object.prototype.hasOwnProperty.call(byKey, bk)) out.push(byKey[bk]);
      }
      out.sort(function (a, b) {
        return ufProfielsoortLabelFromTag(a).localeCompare(ufProfielsoortLabelFromTag(b), UF_SORT_LOCALE, {
          numeric: true,
          sensitivity: 'base'
        });
      });
      return out;
    }

    function ufAppendMappedFilterOption(ul, group, tag, label) {
      var li = document.createElement('li');
      var lab = document.createElement('label');
      lab.className = 'uf-check';
      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.className = 'uf-filter-checkbox';
      inp.setAttribute('data-group', group);
      inp.setAttribute('data-tag', tag);
      inp.setAttribute('data-tag-handle', ufTagHandleizeShopify(tag));
      var ui = document.createElement('span');
      ui.className = 'uf-check-ui';
      var cap = document.createElement('span');
      cap.className = 'uf-check-label';
      cap.textContent = label;
      lab.appendChild(inp);
      lab.appendChild(ui);
      lab.appendChild(cap);
      li.appendChild(lab);
      ul.appendChild(li);
    }

    function ufSyncPlintenSubfilterVisibility(rootEl) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var plintOn = false;
      var profielOn = false;
      rootEl.querySelectorAll('.uf-filter-checkbox[data-group="plinthoofdsoort"]:checked').forEach(function (inp) {
        var k = ufPlinthoofdsoortKeyFromTag(inp.getAttribute('data-tag'));
        if (k === 'plint') plintOn = true;
        if (k === 'profiel' || k === 'trapprofiel') profielOn = true;
      });
      var plintBlock = rootEl.querySelector('.uf-filter-tree-plintsoort');
      var profBlock = rootEl.querySelector('.uf-filter-tree-profielsoort');
      var showPlint = !profielOn || plintOn;
      var showProf = !plintOn || profielOn;
      if (plintBlock) {
        if (showPlint) {
          plintBlock.hidden = !plintBlock.querySelector('.uf-filter-checkbox');
        } else {
          plintBlock.hidden = true;
          plintBlock.querySelectorAll('.uf-filter-checkbox[data-group="plintsoort"]:checked').forEach(function (inp) {
            inp.checked = false;
          });
        }
      }
      if (profBlock) {
        if (showProf) {
          profBlock.hidden = !profBlock.querySelector('.uf-filter-checkbox');
        } else {
          profBlock.hidden = true;
          profBlock.querySelectorAll('.uf-filter-checkbox[data-group="profielsoort"]:checked').forEach(function (inp) {
            inp.checked = false;
          });
        }
      }
      var tree = rootEl.querySelector('.uf-filter-pvc-tree--plinten');
      if (tree) {
        var hasVisible =
          (plintBlock && !plintBlock.hidden && plintBlock.querySelector('.uf-filter-checkbox')) ||
          (profBlock && !profBlock.hidden && profBlock.querySelector('.uf-filter-checkbox'));
        tree.hidden = !hasVisible;
      }
    }

    function ufSyncPlintsoortFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var ul = rootEl.querySelector('#uf-plintsoort-filter-list');
      if (!ul) return;
      var fromCat = ufCollectPlintsoortTagsFromCatalog(catalog);
      var existing = {};
      ul.querySelectorAll('input[data-group="plintsoort"]').forEach(function (inp) {
        var k = ufPlintsoortKeyFromTag(inp.getAttribute('data-tag'));
        if (k) existing[k] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var key = ufPlintsoortKeyFromTag(tag);
        if (!key || existing[key]) continue;
        existing[key] = true;
        ufAppendMappedFilterOption(ul, 'plintsoort', tag, ufPlintsoortLabelFromTag(tag));
      }
    }

    function ufSyncProfielsoortFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var ul = rootEl.querySelector('#uf-profielsoort-filter-list');
      if (!ul) return;
      var fromCat = ufCollectProfielsoortTagsFromCatalog(catalog);
      var existing = {};
      ul.querySelectorAll('input[data-group="profielsoort"]').forEach(function (inp) {
        var k = ufProfielsoortKeyFromTag(inp.getAttribute('data-tag'));
        if (k) existing[k] = true;
      });
      for (var i = 0; i < fromCat.length; i++) {
        var tag = fromCat[i];
        var key = ufProfielsoortKeyFromTag(tag);
        if (!key || existing[key]) continue;
        existing[key] = true;
        ufAppendMappedFilterOption(ul, 'profielsoort', tag, ufProfielsoortLabelFromTag(tag));
      }
    }

    function ufSyncHoogteFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var ul = rootEl.querySelector('#uf-hoogte-filter-list');
      if (!ul) return;
      var opts = ufCollectHoogteOptionsFromCatalog(catalog);
      if (!opts.length) return;
      var existing = {};
      ul.querySelectorAll('input[data-group="hoogte"]').forEach(function (inp) {
        var k = ufHoogteKeyFromTag(inp.getAttribute('data-tag'));
        if (k) existing[k] = true;
      });
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (existing[o.key]) continue;
        existing[o.key] = true;
        ufAppendMappedFilterOption(ul, 'hoogte', o.tag, o.label);
      }
    }

    function ufSyncPlintenDikteFilterOptions(rootEl, catalog) {
      if (!rootEl || rootEl.getAttribute('data-uf-plinten') !== 'true') return;
      var ul = rootEl.querySelector('#uf-plinten-dikte-filter-list');
      if (!ul) return;
      var opts = ufCollectDikteOptionsFromCatalog(catalog);
      if (!opts.length) return;
      var existing = {};
      ul.querySelectorAll('input[data-group="dikte"]').forEach(function (inp) {
        var k = ufDikteKeyFromTag(inp.getAttribute('data-tag'));
        if (k) existing[k] = true;
      });
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (existing[o.key]) continue;
        existing[o.key] = true;
        ufAppendMappedFilterOption(ul, 'dikte', o.tag, o.label);
      }
    }

    function tileMatchesPlintsoort(tileTags, selectedPlintsoortTags, title, handle, productType) {
      if (!selectedPlintsoortTags || selectedPlintsoortTags.length === 0) return true;
      var have = ufPlintsoortKeysFromProduct(tileTags, title, handle, productType);
      for (var i = 0; i < selectedPlintsoortTags.length; i++) {
        var k = ufPlintsoortKeyFromTag(selectedPlintsoortTags[i]);
        if (k && have[k]) return true;
      }
      return false;
    }

    function tileMatchesProfielsoort(tileTags, selectedProfielsoortTags, title, handle) {
      if (!selectedProfielsoortTags || selectedProfielsoortTags.length === 0) return true;
      var have = ufProfielsoortKeysFromProduct(tileTags, title, handle);
      for (var i = 0; i < selectedProfielsoortTags.length; i++) {
        var k = ufProfielsoortKeyFromTag(selectedProfielsoortTags[i]);
        if (k && have[k]) return true;
        var navTag = ufProfielsoortTagFromProfieltypeNav(selectedProfielsoortTags[i]);
        if (navTag && have[ufProfielsoortKeyFromTag(navTag)]) return true;
      }
      return false;
    }

    function tileMatchesProfieltype(tileTags, selectedProfieltypeTags, title, handle) {
      return tileMatchesProfielsoort(tileTags, selectedProfieltypeTags, title, handle);
    }

    function tileMatchesGroup(tileTags, groupName, selectedArr, rowMeta) {
      if (!selectedArr || selectedArr.length === 0) return true;
      rowMeta = rowMeta || {};
      if (groupName === 'soort') {
        return tileMatchesSoort(tileTags, selectedArr, rowMeta.title || '', rowMeta.product_type || '');
      }
      if (groupName === 'pvctype') return tileMatchesPvctype(tileTags, selectedArr);
      if (groupName === 'merk') {
        return tileMatchesMerk(tileTags, selectedArr, rowMeta.vendor || '', rowMeta.title || '');
      }
      if (groupName === 'assortiment') return tileMatchesAssortiment(tileTags, selectedArr);
      if (groupName === 'productgroep') return tileMatchesProductgroep(tileTags, selectedArr);
      if (groupName === 'accsoort') return tileMatchesAccsoort(tileTags, selectedArr);
      if (groupName === 'profieltype') {
        return tileMatchesProfielsoort(tileTags, selectedArr, rowMeta.title || '', rowMeta.handle || '');
      }
      if (groupName === 'plinthoofdsoort') {
        return tileMatchesPlinthoofdsoort(
          tileTags,
          selectedArr,
          rowMeta.title || '',
          rowMeta.handle || '',
          rowMeta.product_type || ''
        );
      }
      if (groupName === 'plintsoort') {
        return tileMatchesPlintsoort(
          tileTags,
          selectedArr,
          rowMeta.title || '',
          rowMeta.handle || '',
          rowMeta.product_type || ''
        );
      }
      if (groupName === 'profielsoort') {
        return tileMatchesProfielsoort(tileTags, selectedArr, rowMeta.title || '', rowMeta.handle || '');
      }
      if (groupName === 'kleur' || groupName === 'kleurtype') return tileMatchesKleurGroup(tileTags, selectedArr);
      if (groupName === 'vgroeven') return tileMatchesVgroeven(tileTags, selectedArr);
      if (groupName === 'slijtlaag') return tileMatchesSlijtlaag(tileTags, selectedArr);
      if (groupName === 'vftype') return tileMatchesVftype(tileTags, selectedArr);
      if (groupName === 'lengte') return tileMatchesLengte(tileTags, selectedArr, rowMeta.title || '');
      if (groupName === 'breedte') return tileMatchesBreedte(tileTags, selectedArr, rowMeta.title || '');
      if (groupName === 'dikte') return tileMatchesDikte(tileTags, selectedArr);
      if (groupName === 'hoogte') return tileMatchesHoogte(tileTags, selectedArr);
      if (groupName === 'onderlaag') return tileMatchesOnderlaag(tileTags, selectedArr);
      if (groupName === 'waterbestendig') return tileMatchesWaterbestendig(tileTags, selectedArr);
      if (groupName === 'geluid') return tileMatchesGeluid(tileTags, selectedArr);
      for (var i = 0; i < selectedArr.length; i++) {
        var sel = selectedArr[i];
        for (var j = 0; j < (tileTags || []).length; j++) {
          if (ufFilterTagsEquivalent(groupName, tileTags[j], sel)) return true;
        }
      }
      return false;
    }

    var UF_FILTER_TAG_GROUPS_PVC = ['pvctype', 'soort', 'kleur', 'kleurtype', 'merk', 'lengte', 'breedte', 'dikte', 'slijtlaag', 'onderlaag', 'vgroeven', 'waterbestendig', 'geluid', 'vftype'];
    var UF_FILTER_TAG_GROUPS_PLINTEN = ['plinthoofdsoort', 'productgroep', 'plintsoort', 'profielsoort', 'kleur', 'kleurtype', 'merk', 'hoogte', 'dikte'];
    var UF_FILTER_TAG_GROUPS_TRAPRENOVATIE = ['productgroep', 'soort', 'kleur', 'kleurtype', 'merk', 'lengte', 'breedte', 'dikte', 'vgroeven', 'waterbestendig', 'vftype'];
    var UF_FILTER_TAG_GROUPS_ACCESSOIRES = ['pvctype', 'merk'];
    var UF_ACCESSOIRES_SCHOONMAAK_TAG = 'Assortiment: Schoonmaakspullen';
    var UF_ACCESSOIRES_SCHOONMAAK_ACCSOORT_KEYS = {
      reiniger: true,
      vlekverwijderaar: true,
      polish: true,
      'polish remover': true,
      'pvc reiniger': true
    };

    function ufAccessoiresHasSchoonmaakAccsoort(tileTags) {
      for (var si = 0; si < (tileTags || []).length; si++) {
        var sk = ufAccsoortKeyFromTag(tileTags[si]);
        if (sk && UF_ACCESSOIRES_SCHOONMAAK_ACCSOORT_KEYS[sk]) return true;
      }
      return false;
    }

    function ufHasSegmentTag(tags, segment) {
      var want = 'segment: ' + segment;
      for (var si = 0; si < (tags || []).length; si++) {
        if (String(tags[si] || '').toLowerCase().trim() === want) return true;
      }
      return false;
    }

    function ufProductBelongsOnAccessoiresPage(tags) {
      if (ufHasSegmentTag(tags, 'plint') || ufHasSegmentTag(tags, 'plinten')) return false;
      return ufHasSegmentTag(tags, 'accessoire');
    }

    function ufAccessoiresSegmentGate(tags) {
      var rootEl = document.getElementById('uf-mapped-filters');
      if (!rootEl || rootEl.getAttribute('data-uf-accessoires') !== 'true') return true;
      return ufProductBelongsOnAccessoiresPage(tags);
    }

    function ufTraprenovatieTrapprofielGate(tags, title, handle) {
      var rootEl = document.getElementById('uf-mapped-filters');
      if (!rootEl || rootEl.getAttribute('data-uf-traprenovatie') !== 'true') return true;
      var t = String(title || '').toLowerCase();
      var h = String(handle || '').toLowerCase();
      if (t.indexOf('trapprofiel') !== -1 || h.indexOf('trapprofiel') !== -1) return false;
      for (var i = 0; i < (tags || []).length; i++) {
        if (String(tags[i] || '').toLowerCase().indexOf('trapprofiel') !== -1) return false;
      }
      return true;
    }

    function ufFilterTagGroups() {
      var rootEl = document.getElementById('uf-mapped-filters');
      if (rootEl && rootEl.getAttribute('data-uf-accessoires') === 'true') {
        return UF_FILTER_TAG_GROUPS_ACCESSOIRES.slice();
      }
      if (rootEl && rootEl.getAttribute('data-uf-plinten') === 'true') {
        return UF_FILTER_TAG_GROUPS_PLINTEN.slice();
      }
      if (rootEl && rootEl.getAttribute('data-uf-traprenovatie') === 'true') {
        return UF_FILTER_TAG_GROUPS_TRAPRENOVATIE.slice();
      }
      return UF_FILTER_TAG_GROUPS_PVC.slice();
    }

    function ufTagFilterSelectionActive(selected) {
      var tagGroups = ufFilterTagGroups();
      for (var i = 0; i < tagGroups.length; i++) {
        var g = tagGroups[i];
        if (selected[g] && selected[g].length > 0) return true;
      }
      return false;
    }

    function ufTileOrRowMatches(tags, price, min, max, selected, groups, title, productType, vendor, handle) {
      if (!ufAccessoiresSegmentGate(tags)) return false;
      if (!ufTraprenovatieTrapprofielGate(tags, title, handle || '')) return false;
      var pr = parseInt(price, 10);
      if (isNaN(pr)) pr = -1;
      if (pr < min || pr > max) return false;
      var rowMeta = { title: title || '', product_type: productType || '', vendor: vendor || '', handle: handle || '' };
      for (var gi = 0; gi < groups.length; gi++) {
        var g = groups[gi];
        var sel = selected[g] || [];
        if (sel.length === 0) continue;
        if (!tileMatchesGroup(tags, g, sel, rowMeta)) return false;
      }
      return true;
    }

    function ufHandlesSortedFromCheckboxes(root) {
      if (window.UfFilterUrl && typeof window.UfFilterUrl.pathHandlesFromCheckboxes === 'function') {
        return window.UfFilterUrl.pathHandlesFromCheckboxes(root);
      }
      var h = [];
      root.querySelectorAll('.uf-filter-checkbox:checked').forEach(function (b) {
        var th = b.getAttribute('data-tag-handle');
        if (th) h.push(th);
      });
      h.sort();
      return h;
    }

    function ufHandlesFromPathname(base) {
      var p = window.location.pathname || '';
      var b = (base || '').replace(/\/$/, '');
      if (p === b || p === b + '/') return [];
      var prefix = b + '/';
      if (p.indexOf(prefix) !== 0) return [];
      var rest = p.slice(prefix.length).split('?')[0];
      if (!rest) return [];
      try {
        rest = decodeURIComponent(rest);
      } catch (e1) {}
      return rest.split('+').filter(Boolean).map(function (s) { return s.trim(); }).sort();
    }

    function ufSameSortedHandles(a, b) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }

    function ufMaybeRedirectForPagedTagFilter(root, min, max, selected, productTiles, groups) {
      if (ufProductCatalog && ufProductCatalog.length > 0) return;
      if (!root || !ufCollectionCountRows || !ufCollectionCountRows.length) return;
      if (!ufTagFilterSelectionActive(selected)) return;

      var matchTotal = 0;
      for (var ri = 0; ri < ufCollectionCountRows.length; ri++) {
        var row = ufCollectionCountRows[ri];
        if (ufTileOrRowMatches(row.tags || [], row.price, min, max, selected, groups, row.title, row.product_type, row.vendor, row.handle)) matchTotal++;
      }
      if (matchTotal === 0) return;

      var visibleOnPage = 0;
      for (var ti = 0; ti < productTiles.length; ti++) {
        var el = productTiles[ti];
        var price = parseInt(el.getAttribute('data-product-price'), 10);
        var raw = el.getAttribute('data-product-tags') || '';
        var tags = raw ? raw.split('||') : [];
        if (ufTileOrRowMatches(tags, price, min, max, selected, groups, el.getAttribute('data-product-title') || '', el.getAttribute('data-product-type') || '', el.getAttribute('data-product-vendor') || '', el.getAttribute('data-product-handle') || '')) visibleOnPage++;
      }
      if (visibleOnPage > 0) return;

      var baseRaw = root.getAttribute('data-collection-base');
      if (!baseRaw) return;
      var base = baseRaw.replace(/\/$/, '');
      var want = ufHandlesSortedFromCheckboxes(root);
      if (!want.length) return;

      var cur = ufHandlesFromPathname(base);
      var params = new URLSearchParams(window.location.search || '');
      var pageNum = parseInt(params.get('page') || '1', 10);

      var needRedirect = false;
      if (!ufSameSortedHandles(want, cur)) needRedirect = true;
      else if (pageNum > 1) needRedirect = true;
      if (!needRedirect) return;

      if (window.__ufTagFilterRedirecting) return;
      window.__ufTagFilterRedirecting = true;
      params.delete('page');
      var q = params.toString();
      var suffix = q ? '?' + q : '';
      window.location.assign(base + '/' + want.join('+') + suffix);
    }

    /**
     * Als de URL al getagd is (/collections/handle/tag1+tag2), moeten pad en checkboxes gelijk lopen.
     * Anders blijft de server-HTML een subset en kun je niet terug naar de volle collectie.
     * Op een kale collection-URL (geen pad-tags): geen redirect â€” filter blijft client-side.
     * Tellingen: aparte JSON-fetch op data-collection-base (volledige collectie).
     */
    function ufSyncFilterUrlToCheckboxes(usePush) {
      if (ufFilterApplyingFromHistory) return;
      if (!ufProductCatalog || !ufProductCatalog.length) return;
      try {
        var built = ufCollectionBuildFilterUrl(window.__ufCurrentCollectionSort || 'manual');
        built.searchParams.delete('uf_group');
        built.searchParams.delete('uf_tag');
        if (ufClientListPage > 1) built.searchParams.set('page', String(ufClientListPage));
        var newUrl = built.pathname + built.search + built.hash;
        var curUrl = window.location.pathname + window.location.search + window.location.hash;
        if (newUrl === curUrl) return;
        var state = { ufFilters: 1 };
        if (usePush && ufFiltersHistoryReady) history.pushState(state, '', newUrl);
        else history.replaceState(state, '', newUrl);
      } catch (eUrl) {}
    }

    function ufMaybeRedirectTagUrlToMatchCheckboxes(root) {
      if (!root || window.__ufTagFilterRedirecting) return;
      if (ufProductCatalog && ufProductCatalog.length > 0) {
        ufSyncFilterUrlToCheckboxes(false);
        return;
      }
      var baseRaw = root.getAttribute('data-collection-base');
      if (!baseRaw || !window.UfFilterUrl) return;

      var sortBy = 'manual';
      try {
        sortBy = new URLSearchParams(window.location.search || '').get('sort_by') || 'manual';
      } catch (eSortR) {}

      var dest = window.UfFilterUrl.canonicalUrlFromRoot(root, sortBy);
      var cur = window.location.pathname + window.location.search + window.location.hash;
      if (dest === cur) return;

      var needsRedirect =
        window.UfFilterUrl.needsLegacySearchRedirect(root, baseRaw) ||
        window.UfFilterUrl.pathHasMultipleInSameGroup(root, baseRaw);
      if (!needsRedirect) return;

      window.__ufTagFilterRedirecting = true;
      window.location.replace(dest);
    }

    /**
     * Timber-grid gebruikt float + :nth-child(3n+1){clear:both} voor kolommen.
     * Met hidden/display verborgen nodes tellen nog mee voor nth-child â†’ gaten in het raster.
     * Zichtbare tegels eerst in de DOM zetten = netjes opvullen (zelfde grid, geen pure CSS-hack).
     */
    function ufPackFilteredTilesFirst() {
      var grid = document.getElementById('uf-col-product-grid');
      if (!grid) return;
      var tiles = Array.prototype.slice.call(
        grid.querySelectorAll('.grid__item[data-product-tags][data-product-price]')
      );
      if (!tiles.length) return;
      var vis = [];
      var hid = [];
      tiles.forEach(function (t) {
        if (t.hidden) hid.push(t);
        else vis.push(t);
      });
      vis.concat(hid).forEach(function (t) {
        grid.appendChild(t);
      });
    }

    function ufFilterTagDisplayLabel(raw) {
      var s = String(raw == null ? '' : raw).trim();
      var i = s.indexOf(':');
      if (i >= 0) return s.slice(i + 1).trim();
      return s;
    }

    function ufEscapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function ufEscapeAttr(s) {
      return ufEscapeHtml(s).replace(/'/g, '&#39;');
    }

    function ufFormatMoneyCents(cents) {
      try {
        if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
          return Shopify.formatMoney(cents, window.money_format);
        }
      } catch (eM) {}
      return centsToEUR(cents);
    }

    function ufRoundPerM2DisplayCentsLocal(c) {
      if (typeof window.ufRoundPerM2DisplayCents === 'function') return window.ufRoundPerM2DisplayCents(c);
      var n = Math.round(Number(c));
      if (!isFinite(n) || n < 0) n = 0;
      return Math.round(n / 5) * 5;
    }

    /** UF-03: 'piece' | 'm2' | 'none' — collectie-attr of producttags. */
    function ufResolveCardPriceUnit(root, tags) {
      if (root && root.getAttribute('data-uf-traprenovatie') === 'true') return 'none';
      var priceUnit = root ? root.getAttribute('data-uf-price-unit') || '' : '';
      if (priceUnit === 'none') return 'none';
      if (
        priceUnit === 'piece' ||
        (root && root.getAttribute('data-uf-plinten') === 'true') ||
        (root && root.getAttribute('data-uf-accessoires') === 'true')
      ) {
        return 'piece';
      }
      var list = tags || [];
      for (var i = 0; i < list.length; i++) {
        var t = String(list[i] || '')
          .trim()
          .toLowerCase();
        if (t === 'segment: traprenovatie' || t === 'traprenovatie') return 'none';
        if (
          t === 'segment: accessoire' ||
          t === 'segment: plint' ||
          t === 'segment: plinten' ||
          t === 'accessoires' ||
          t === 'accessoire'
        ) {
          return 'piece';
        }
      }
      return 'm2';
    }

    function ufShopifyImageWidthUrl(url, width) {
      var u = String(url || '').trim();
      if (!u || !width) return u;
      var w = String(width);
      if (/([?&])width=\d+/i.test(u)) return u.replace(/([?&])width=\d+/i, '$1width=' + w);
      if (/_\d+x(\d*)(\.[a-z]+)(\?|$)/i.test(u)) {
        return u.replace(/_(\d+)x(\d*)(\.[a-z]+)(\?|$)/i, '_' + w + 'x$3$4');
      }
      if (/(\.[a-z]+)(\?|$)/i.test(u) && u.indexOf('/cdn/') !== -1) {
        return u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
      }
      return u;
    }

    function ufCardSrcsetFromMain(main600) {
      var m600 = String(main600 || '').trim();
      if (!m600) return { src: '', srcset: '' };
      var m300 = ufShopifyImageWidthUrl(m600, 300);
      var m450 = ufShopifyImageWidthUrl(m600, 450);
      var m600u = ufShopifyImageWidthUrl(m600, 600) || m600;
      return {
        src: m600u,
        srcset: m300 + ' 300w, ' + m450 + ' 450w, ' + m600u + ' 600w'
      };
    }

    function ufHasActiveTagSelection(selected) {
      if (window.__ufNavProfieltypeFilter || window.__ufNavKleurtypeFilter) return true;
      if (!selected) return false;
      for (var k in selected) {
        if (Object.prototype.hasOwnProperty.call(selected, k) && selected[k] && selected[k].length) {
          return true;
        }
      }
      return false;
    }

    function ufShouldKeepSsrGrid(min, max, selected) {
      if (!ufSsrGridIntact) return false;
      if (ufClientListPage > 1) return false;
      var sort = String(window.__ufCurrentCollectionSort || 'manual').trim();
      if (sort && sort !== 'manual') return false;
      if (ufHasActiveTagSelection(selected)) return false;
      var grid = document.getElementById('uf-col-product-grid');
      if (!grid) return false;
      if (grid.querySelector('[data-uf-catalog="1"]')) {
        ufSsrGridIntact = false;
        return false;
      }
      if (!grid.querySelector('.grid__item[data-product-tags]')) return false;
      var minEl = document.querySelector('#uf-mapped-filters #uf-price-min');
      var maxEl = document.querySelector('#uf-mapped-filters #uf-price-max');
      if (minEl && maxEl) {
        var aMin = parseInt(minEl.min, 10);
        var aMax = parseInt(minEl.max, 10);
        if (isFinite(aMin) && isFinite(aMax) && aMax >= aMin) {
          if (min > aMin || max < aMax) return false;
        }
      }
      return true;
    }

    function ufRenderClientGridPage() {
      var grid = document.getElementById('uf-col-product-grid');
      var root = document.getElementById('uf-mapped-filters');
      if (!grid || !root) return;

      ufSsrGridIntact = false;

      var perPage = parseInt(root.getAttribute('data-uf-per-page') || '24', 10);
      if (!perPage || perPage < 1) perPage = 24;

      var refClass = window.__ufGridItemClass;
      if (!refClass) {
        var fo = grid.querySelector('.grid__item[data-product-tags]');
        if (fo && !fo.getAttribute('data-uf-catalog')) {
          refClass = fo.className.replace(/\s*dividerof\s*/gi, ' ').replace(/\s+/g, ' ').trim();
        } else {
          refClass = 'grid__item grid_less_padding large--one-quarter medium--one-half margin--bottom-15 small--one-half custom--width-one-half';
        }
        window.__ufGridItemClass = refClass;
      }

      var list = ufFilteredProductList || [];
      var total = list.length;
      var pages = Math.max(1, Math.ceil(total / perPage));
      if (ufClientListPage > pages) ufClientListPage = pages;
      if (ufClientListPage < 1) ufClientListPage = 1;
      var start = (ufClientListPage - 1) * perPage;
      var slice = list.slice(start, start + perPage);

      var unavailable = root.getAttribute('data-uf-unavailable') || '';
      var noMatches = root.getAttribute('data-uf-no-matches') || '';
      var transparentSrc = root.getAttribute('data-uf-transparent') || '';
      var cardSizes = '(min-width: 900px) 25vw, (min-width: 560px) 50vw, 50vw';

      function tagsJoin(tags) {
        return (tags || []).join('||');
      }

      var parts = [];
      if (total === 0) {
        parts.push(
          '<div class="grid__item large--one-whole"><p class="thi">' +
            ufEscapeHtml(noMatches) +
            '</p></div>'
        );
      } else {
        for (var j = 0; j < slice.length; j++) {
          var p = slice[j];
          var tagsStr = tagsJoin(p.tags);
          var titleH = ufEscapeHtml(p.title);
          var urlA = ufEscapeAttr(p.url);
          var srcsetInfo = ufCardSrcsetFromMain(p.image || '');
          var mainA = ufEscapeAttr(srcsetInfo.src || p.image || '');
          var srcsetA = ufEscapeAttr(srcsetInfo.srcset || '');
          var altA = ufEscapeAttr(p.imageAlt || p.title || '');
          var tagsA = ufEscapeAttr(tagsStr);
          var imgs600raw = p.images600 || p.image || '';
          var imgsA = ufEscapeAttr(imgs600raw);
          var hasSecond = !!p.hasSecond && !!(p.hover275 || '').trim();
          var imgClass = hasSecond ? 'first--image' : '';
          var eager = j < 4;
          var innerImgs =
            '<img src="' +
            mainA +
            (srcsetA ? '" srcset="' + srcsetA + '" sizes="' + cardSizes : '') +
            '" data-primary-src="' +
            mainA +
            '" alt="' +
            altA +
            '" loading="' +
            (eager ? 'eager' : 'lazy') +
            '" decoding="async"' +
            (j === 0 ? ' fetchpriority="high"' : '') +
            ' class="' +
            imgClass +
            '" />';
          if (hasSecond && p.hover275) {
            innerImgs +=
              '<img src="' +
              ufEscapeAttr(transparentSrc) +
              '" data-src="' +
              ufEscapeAttr(p.hover275) +
              '" data-size="auto" loading="lazy" decoding="async" class="lazyload second--image" alt="' +
              titleH +
              '" height="" />';
          }
          var merkLabel = ufMerkDisplayFromProduct(p.tags, p.title, p.product_type);
          var merkHtml = merkLabel
            ? '<span class="uf-home-product__merk">' + ufEscapeHtml(merkLabel) + '</span>'
            : '';
          var imgUrls = imgs600raw.split('||').filter(function (u) {
            return u && u.length > 0;
          });
          var multiImg = imgUrls.length > 1;
          var navHtml = '';
          if (multiImg) {
            navHtml =
              '<button type="button" class="uf-card-nav uf-card-nav--prev" aria-label="Vorige afbeelding">&#10095;</button>' +
              '<button type="button" class="uf-card-nav uf-card-nav--next" aria-label="Volgende afbeelding">&#10094;</button>';
          }
          var priceRow = '';
          if (p.available) {
            var pCur = ufRoundPerM2DisplayCentsLocal(p.price);
            var pCmp = p.compareAt > p.price ? ufRoundPerM2DisplayCentsLocal(p.compareAt) : 0;
            var cur = ufFormatMoneyCents(pCur);
            var cmp = pCmp > 0 ? ufFormatMoneyCents(pCmp) : '';
            priceRow = '<div class="uf-collection-card-meta__price-row">';
            if (cmp) {
              priceRow += '<span class="uf-collection-card-meta__compare money">' + cmp + '</span>';
            }
            priceRow +=
              '<span class="uf-collection-card-meta__current money">' +
              cur +
              '</span>';
            var resolvedUnit = ufResolveCardPriceUnit(root, p.tags);
            if (resolvedUnit !== 'none') {
              priceRow +=
                '<span class="uf-collection-card-meta__unit">' +
                (resolvedUnit === 'piece' ? 'per stuk' : 'per m\u00b2') +
                '</span>';
            }
            priceRow += '</div>';
          } else {
            priceRow =
              '<span class="uf-collection-card-meta__unavailable">' + ufEscapeHtml(unavailable) + '</span>';
          }
          parts.push(
            '<div class="' +
              String(refClass).replace(/"/g, '') +
              '" data-uf-catalog="1" data-product-tags="' +
              tagsA +
              '" data-product-title="' +
              ufEscapeAttr(p.title || '') +
              '" data-product-handle="' +
              ufEscapeAttr(p.handle || '') +
              '" data-product-type="' +
              ufEscapeAttr(p.product_type || '') +
              '" data-product-vendor="' +
              ufEscapeAttr(p.vendor || '') +
              '" data-product-price="' +
              String(p.available ? ufRoundPerM2DisplayCentsLocal(p.price) : p.price) +
              '" data-product-images="' +
              imgsA +
              '">' +
              '<div class="grid_collection_box uf-collection-tile--meta-below" data-product-options-wrapper>' +
              '<div class="grid__product-image text-center">' +
              '<a href="' +
              urlA +
              '" class="grid__image">' +
              innerImgs +
              merkHtml +
              '</a>' +
              navHtml +
              '</div>' +
              '<a href="' +
              urlA +
              '" class="uf-collection-card-meta">' +
              '<h4 class="uf-collection-card-meta__title">' +
              titleH +
              '</h4>' +
              '<div class="uf-collection-card-meta__price">' +
              priceRow +
              '</div></a>' +
              '<div class="grid__product-content text-center category_detail"></div>' +
              '</div></div>'
          );
        }
      }
      grid.innerHTML = parts.join('');
      try {
        var ls = window.lazySizes;
        var unveil =
          ls &&
          (typeof ls.unveil === 'function'
            ? ls.unveil
            : ls.loader && typeof ls.loader.unveil === 'function'
              ? ls.loader.unveil.bind(ls.loader)
              : null);
        if (unveil) {
          var lzNodes = grid.querySelectorAll('.lazyload');
          for (var lz = 0; lz < lzNodes.length; lz++) {
            try {
              unveil(lzNodes[lz]);
            } catch (eLz) {}
          }
        }
      } catch (eLs) {}
    }

    function ufRenderClientPagination() {
      var wrap = document.getElementById('uf-col-pagination');
      var root = document.getElementById('uf-mapped-filters');
      if (!wrap || !root) return;

      var perPage = parseInt(root.getAttribute('data-uf-per-page') || '24', 10);
      if (!perPage || perPage < 1) perPage = 24;
      var total = ufFilteredProductList.length;
      var pages = Math.max(1, Math.ceil(total / perPage));

      if (pages <= 1) {
        wrap.innerHTML = '';
        return;
      }

      var html = '<hr><div class="pagination uf-col-pagination-inner">';
      for (var p = 1; p <= pages; p++) {
        if (p === ufClientListPage) {
          html += '<span class="page current">' + p + '</span>';
        } else {
          html += '<span class="page"><a href="#" data-uf-page="' + p + '">' + p + '</a></span>';
        }
      }
      html += '</div>';
      wrap.innerHTML = html;
    }

    var UF_SORT_CLIENT_ONLY = {
      'title-ascending': true,
      'title-descending': true,
      'price-ascending': true,
      'price-descending': true,
      manual: true
    };

    window.__ufCurrentCollectionSort =
      (function () {
        try {
          return new URLSearchParams(window.location.search || '').get('sort_by') || 'manual';
        } catch (eS0) {
          return 'manual';
        }
      })() || 'manual';

    function ufSortCatalogProducts(list, sortKey) {
      var key = String(sortKey || 'manual').trim();
      var out = (list || []).slice();
      if (key === 'title-ascending') {
        out.sort(function (a, b) {
          return String(a.title || '').localeCompare(String(b.title || ''), 'nl', { numeric: true, sensitivity: 'base' });
        });
      } else if (key === 'title-descending') {
        out.sort(function (a, b) {
          return String(b.title || '').localeCompare(String(a.title || ''), 'nl', { numeric: true, sensitivity: 'base' });
        });
      } else if (key === 'price-ascending') {
        out.sort(function (a, b) {
          return (a.price || 0) - (b.price || 0);
        });
      } else if (key === 'price-descending') {
        out.sort(function (a, b) {
          return (b.price || 0) - (a.price || 0);
        });
      } else {
        out.sort(function (a, b) {
          return (a._ufOrder || 0) - (b._ufOrder || 0);
        });
      }
      return out;
    }

    function ufCollectionBuildFilterUrl(sortBy) {
      if (window.UfFilterUrl && typeof window.UfFilterUrl.buildFilterUrl === 'function') {
        var rootEl = document.getElementById('uf-mapped-filters');
        return window.UfFilterUrl.buildFilterUrl(rootEl, sortBy, window.location.href);
      }
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('uf_group');
      url.searchParams.delete('uf_tag');
      if (sortBy) url.searchParams.set('sort_by', String(sortBy));
      else url.searchParams.delete('sort_by');
      var rootEl = document.getElementById('uf-mapped-filters');
      if (rootEl) {
        var baseRaw = rootEl.getAttribute('data-collection-base');
        if (baseRaw) {
          var base = baseRaw.split('?')[0].replace(/\/$/, '');
          var handles = ufHandlesSortedFromCheckboxes(rootEl);
          url.pathname = handles.length ? base + '/' + handles.join('+') : base;
        }
      }
      return url;
    }

    window.__ufCollectionApplySort = function (sortValue) {
      var value = String(sortValue || 'manual').trim();
      window.__ufCurrentCollectionSort = value;

      if (ufProductCatalog && ufProductCatalog.length && UF_SORT_CLIENT_ONLY[value]) {
        ufFilteredProductList = ufSortCatalogProducts(ufFilteredProductList, value);
        ufClientListPage = 1;
        ufRenderClientGridPage();
        ufRenderClientPagination();
        try {
          var uStay = ufCollectionBuildFilterUrl(value);
          history.replaceState({}, '', uStay.pathname + uStay.search + uStay.hash);
        } catch (eStay) {}
        if (typeof window.ufCollectionGridCardsInit === 'function') {
          window.ufCollectionGridCardsInit();
        }
        return;
      }

      try {
        window.location.assign(ufCollectionBuildFilterUrl(value).toString());
      } catch (eNav) {
        var params = {};
        try {
          (window.location.search || '')
            .substr(1)
            .split('&')
            .forEach(function (pair) {
              var parts = pair.split('=');
              if (parts.length > 1) {
                params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1].replace(/\+/g, ' '));
              }
            });
        } catch (eP) {}
        params.sort_by = value;
        var qs = Object.keys(params)
          .map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
          })
          .join('&');
        window.location.search = qs ? '?' + qs : '?sort_by=' + encodeURIComponent(value);
      }
    };

    function ufApplyClientProductGrid(min, max, selected, groups) {
      var filtered = [];
      for (var i = 0; i < ufProductCatalog.length; i++) {
        var p = ufProductCatalog[i];
        if (!ufProductHasImageFromRow(p)) continue;
        if (ufTileOrRowMatches(p.tags, p.price, min, max, selected, groups, p.title, p.product_type, p.vendor, p.handle)) filtered.push(p);
      }
      ufFilteredProductList = ufSortCatalogProducts(filtered, window.__ufCurrentCollectionSort);

      if (ufShouldKeepSsrGrid(min, max, selected)) {
        var gridKeep = document.getElementById('uf-col-product-grid');
        if (gridKeep) {
          gridKeep.querySelectorAll('.grid__item[data-product-tags]').forEach(function (tile) {
            tile.hidden = false;
          });
        }
        ufRenderClientPagination();
        if (typeof window.ufCollectionGridCardsInit === 'function') {
          window.ufCollectionGridCardsInit();
        }
        return;
      }

      ufRenderClientGridPage();
      ufRenderClientPagination();
      if (typeof window.ufCollectionGridCardsInit === 'function') {
        window.ufCollectionGridCardsInit();
      }
    }

    /**
     * Liquid zoekt swatches alleen in collection.products (eerste pagina) â†’ veel placeholders.
     * Na ufProductCatalog: eerste product in de hele collectie met die tag + afbeelding.
     */
    function ufFillKleurThumbsFromCatalog() {
      if (!ufProductCatalog || !ufProductCatalog.length) return;
      var sel =
        '#uf-mapped-filters .uf-filter-checkbox[data-group="kleur"],' +
        '#uf-mapped-filters .uf-filter-checkbox[data-group="kleurtype"]';
      document.querySelectorAll(sel).forEach(function (inp) {
        var label = inp.closest('label');
        if (!label) return;
        var thumbWrap = label.querySelector('.uf-kleur-filter-thumb');
        if (!thumbWrap) return;
        var ph = thumbWrap.querySelector('.uf-kleur-filter-thumb__ph');
        var img = thumbWrap.querySelector('img');
        if (img && (img.getAttribute('src') || '').trim() && !ph) return;

        var tag = inp.getAttribute('data-tag');
        if (!tag) return;
        var tagLow = String(tag).toLowerCase().trim();

        var url = '';
        for (var i = 0; i < ufProductCatalog.length; i++) {
          var p = ufProductCatalog[i];
          var tgs = p.tags || [];
          var hit = tgs.indexOf(tag) !== -1;
          if (!hit) {
            for (var ti = 0; ti < tgs.length; ti++) {
              if (String(tgs[ti] || '').toLowerCase().trim() === tagLow) {
                hit = true;
                break;
              }
            }
          }
          if (hit && (p.thumb144 || p.image)) {
            url = p.thumb144 || p.image;
            break;
          }
        }
        if (!url) return;

        while (thumbWrap.firstChild) thumbWrap.removeChild(thumbWrap.firstChild);
        var im = document.createElement('img');
        im.src = url;
        im.setAttribute('alt', '');
        im.width = 52;
        im.height = 52;
        im.loading = 'lazy';
        im.decoding = 'async';
        thumbWrap.appendChild(im);
      });
    }

    function ufEnsurePaginationClickDelegate() {
      if (window.__ufColPagBound) return;
      window.__ufColPagBound = true;
      document.addEventListener('click', function (e) {
        var el = e.target;
        while (el && el.nodeType !== 1) el = el.parentNode;
        var a = el && el.closest ? el.closest('#uf-col-pagination a[data-uf-page]') : null;
        if (!a) return;
        if (!ufProductCatalog || !ufProductCatalog.length) return;
        e.preventDefault();
        var np = parseInt(a.getAttribute('data-uf-page'), 10);
        if (isNaN(np) || np < 1) return;
        ufClientListPage = np;
        ufRenderClientGridPage();
        ufRenderClientPagination();
        if (typeof window.ufCollectionGridCardsInit === 'function') {
          window.ufCollectionGridCardsInit();
        }
        try {
          var u = new URL(window.location.href);
          if (np <= 1) u.searchParams.delete('page');
          else u.searchParams.set('page', String(np));
          history.replaceState({}, '', u.pathname + u.search + u.hash);
        } catch (eU) {}
        var gridEl = document.getElementById('uf-col-product-grid');
        if (gridEl) {
          var top = gridEl.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo(0, Math.max(0, top));
        }
      });
    }

    function ufRevealColGridAfterDeeplink() {
      if (ufColDeferDeeplinkGridReveal) return;
      try {
        document.documentElement.classList.remove('uf-col-filter-deeplink');
      } catch (eR) {}
    }

    function applyAllFilters(minCents, maxCents) {
      var min = parseInt(minCents, 10);
      var max = parseInt(maxCents, 10);
      if (isNaN(min) || isNaN(max)) {
        ufRevealColGridAfterDeeplink();
        return;
      }

      var selected = getSelectedTags();
      var groups = ufFilterTagGroups();
      var filterKey = JSON.stringify({ min: min, max: max, sel: selected });

      var productTiles = document.querySelectorAll('.grid__item[data-product-tags][data-product-price]');

      if (ufProductCatalog && ufProductCatalog.length > 0) {
        if (ufLastFilterKey !== null && ufLastFilterKey !== filterKey) {
          ufClientListPage = 1;
        }
        ufLastFilterKey = filterKey;

        ufApplyClientProductGrid(min, max, selected, groups);

        var countRows =
          ufCollectionCountRows && ufCollectionCountRows.length > 0
            ? ufCollectionCountRows
            : [];

        ufScheduleUpdateCounts(min, max, selected, countRows, groups);

        var rootFilter = document.getElementById('uf-mapped-filters');
        if (rootFilter) ufMaybeRedirectForPagedTagFilter(rootFilter, min, max, selected, productTiles, groups);
        if (rootFilter) ufMaybeRedirectTagUrlToMatchCheckboxes(rootFilter);
        ufRevealColGridAfterDeeplink();
        if (typeof window.__ufSyncActiveFiltersBar === 'function') {
          try {
            window.__ufSyncActiveFiltersBar();
          } catch (eAfb2) {}
        }
        ufSyncFilterUrlToCheckboxes(ufFiltersHistoryReady && !ufFilterApplyingFromHistory);
        return;
      }

      productTiles.forEach(function (tile) {
        var price = parseInt(tile.getAttribute('data-product-price'), 10);
        var tagsRaw = tile.getAttribute('data-product-tags') || '';
        var tags = tagsRaw ? tagsRaw.split('||') : [];
        var ok =
          ufTileHasProductImage(tile) &&
          ufTileOrRowMatches(tags, price, min, max, selected, groups, tile.getAttribute('data-product-title') || '', tile.getAttribute('data-product-type') || '', tile.getAttribute('data-product-vendor') || '', tile.getAttribute('data-product-handle') || '');
        tile.hidden = !ok;
      });

      var countRows =
        ufCollectionCountRows && ufCollectionCountRows.length > 0
          ? ufCollectionCountRows
          : ufRowsFromTiles(productTiles);

      ufScheduleUpdateCounts(min, max, selected, countRows, groups);

      ufPackFilteredTilesFirst();

      var rootFilter = document.getElementById('uf-mapped-filters');
      if (rootFilter) ufMaybeRedirectForPagedTagFilter(rootFilter, min, max, selected, productTiles, groups);
      if (rootFilter) ufMaybeRedirectTagUrlToMatchCheckboxes(rootFilter);
      ufRevealColGridAfterDeeplink();
      if (typeof window.__ufSyncActiveFiltersBar === 'function') {
        try {
          window.__ufSyncActiveFiltersBar();
        } catch (eAfb) {}
      }
    }

    function ufScheduleUpdateCounts(min, max, selected, rows, groups) {
      ufUpdateCountsPending = {
        min: min,
        max: max,
        selected: selected,
        rows: rows,
        groups: groups
      };
      if (ufUpdateCountsTimer) clearTimeout(ufUpdateCountsTimer);
      ufUpdateCountsTimer = setTimeout(function () {
        ufUpdateCountsTimer = null;
        var p = ufUpdateCountsPending;
        ufUpdateCountsPending = null;
        if (!p) return;
        updateCounts(p.min, p.max, p.selected, p.rows, p.groups);
      }, 80);
    }

    function updateCounts(min, max, selected, rows, groups) {
      var boxes = document.querySelectorAll('#uf-mapped-filters .uf-filter-checkbox');
      if (!boxes || !boxes.length) return;

      var optionsByGroup = {};
      boxes.forEach(function (b) {
        var g = b.getAttribute('data-group');
        var t = b.getAttribute('data-tag');
        if (!g || !t) return;
        if (!optionsByGroup[g]) optionsByGroup[g] = [];
        optionsByGroup[g].push({ box: b, tag: t, orTags: ufOptionOrTagsFromBox(b) });
      });

      // Compute counts per group
      for (var gi = 0; gi < groups.length; gi++) {
        var group = groups[gi];
        var opts = optionsByGroup[group] || [];
        if (!opts.length) continue;

        var neededSet = new Set();
        opts.forEach(function (o) { neededSet.add(o.tag); });

        // For each group we count options only under OTHER-group constraints.
        // This keeps counts in the same group stable when selecting within that group.
        var tagCount = {};

        if (group === 'soort') {
          for (var ti = 0; ti < rows.length; ti++) {
            var rowS = rows[ti];
            var priceS = rowS.price;
            if (isNaN(priceS)) continue;
            if (priceS < min || priceS > max) continue;

            var tileTagsS = rowS.tags || [];

            var okOthersS = true;
            for (var ohS = 0; ohS < groups.length; ohS++) {
              var otherGroupS = groups[ohS];
              if (otherGroupS === 'soort') continue;
              var otherSelS = selected[otherGroupS] || [];
              if (otherSelS.length > 0 && !tileMatchesGroup(tileTagsS, otherGroupS, otherSelS, rowS)) {
                okOthersS = false;
                break;
              }
            }
            if (!okOthersS) continue;

            for (var oi = 0; oi < opts.length; oi++) {
              var oo = opts[oi];
              var wantKey = ufNormalizeSoortTag(oo.tag);
              if (!wantKey) continue;
              var haveKeysS = ufSoortKeysFromProduct(tileTagsS, rowS.title, rowS.product_type);
              if (haveKeysS[wantKey]) tagCount[oo.tag] = (tagCount[oo.tag] || 0) + 1;
            }
          }
        } else if (group === 'pvctype') {
          for (var tiP = 0; tiP < rows.length; tiP++) {
            var rowP = rows[tiP];
            var priceP = rowP.price;
            if (isNaN(priceP)) continue;
            if (priceP < min || priceP > max) continue;

            var tileTagsP = rowP.tags || [];

            var okOthersP = true;
            for (var ohP = 0; ohP < groups.length; ohP++) {
              var otherGroupP = groups[ohP];
              if (otherGroupP === 'pvctype') continue;
              var otherSelP = selected[otherGroupP] || [];
              if (otherSelP.length > 0 && !tileMatchesGroup(tileTagsP, otherGroupP, otherSelP, rowP)) {
                okOthersP = false;
                break;
              }
            }
            if (!okOthersP) continue;

            var haveKeysP = ufPvctypeKeysFromProduct(tileTagsP);
            for (var oiP = 0; oiP < opts.length; oiP++) {
              var ooP = opts[oiP];
              var wantKeyP = ufPvctypeKeyFromTag(ooP.tag);
              if (!wantKeyP || !haveKeysP[wantKeyP]) continue;
              tagCount[ooP.tag] = (tagCount[ooP.tag] || 0) + 1;
            }
          }
        } else if (group === 'merk') {
          for (var tiM = 0; tiM < rows.length; tiM++) {
            var rowM = rows[tiM];
            var priceM = rowM.price;
            if (isNaN(priceM)) continue;
            if (priceM < min || priceM > max) continue;

            var tileTagsM = rowM.tags || [];

            var okOthersM = true;
            for (var ohM = 0; ohM < groups.length; ohM++) {
              var otherGroupM = groups[ohM];
              if (otherGroupM === 'merk') continue;
              var otherSelM = selected[otherGroupM] || [];
              if (otherSelM.length > 0 && !tileMatchesGroup(tileTagsM, otherGroupM, otherSelM, rowM)) {
                okOthersM = false;
                break;
              }
            }
            if (!okOthersM) continue;

            for (var oiM = 0; oiM < opts.length; oiM++) {
              var ooM = opts[oiM];
              if (tileMatchesMerk(tileTagsM, [ooM.tag], rowM.vendor, rowM.title)) tagCount[ooM.tag] = (tagCount[ooM.tag] || 0) + 1;
            }
          }
        } else if (group === 'accsoort') {
          for (var tiAS = 0; tiAS < rows.length; tiAS++) {
            var rowAS = rows[tiAS];
            var priceAS = rowAS.price;
            if (isNaN(priceAS)) continue;
            if (priceAS < min || priceAS > max) continue;

            var tileTagsAS = rowAS.tags || [];

            var okOthersAS = true;
            for (var ohAS = 0; ohAS < groups.length; ohAS++) {
              var otherGroupAS = groups[ohAS];
              if (otherGroupAS === 'accsoort') continue;
              var otherSelAS = selected[otherGroupAS] || [];
              if (otherSelAS.length > 0 && !tileMatchesGroup(tileTagsAS, otherGroupAS, otherSelAS, rowAS)) {
                okOthersAS = false;
                break;
              }
            }
            if (!okOthersAS) continue;

            for (var oiAS = 0; oiAS < opts.length; oiAS++) {
              var ooAS = opts[oiAS];
              if (tileMatchesAccsoort(tileTagsAS, [ooAS.tag])) tagCount[ooAS.tag] = (tagCount[ooAS.tag] || 0) + 1;
            }
          }
        } else if (group === 'plinthoofdsoort') {
          for (var tiPh = 0; tiPh < rows.length; tiPh++) {
            var rowPh = rows[tiPh];
            var pricePh = rowPh.price;
            if (isNaN(pricePh)) continue;
            if (pricePh < min || pricePh > max) continue;

            var tileTagsPh = rowPh.tags || [];

            var okOthersPh = true;
            for (var ohPh = 0; ohPh < groups.length; ohPh++) {
              var otherGroupPh = groups[ohPh];
              if (otherGroupPh === 'plinthoofdsoort') continue;
              var otherSelPh = selected[otherGroupPh] || [];
              if (otherSelPh.length > 0 && !tileMatchesGroup(tileTagsPh, otherGroupPh, otherSelPh, rowPh)) {
                okOthersPh = false;
                break;
              }
            }
            if (!okOthersPh) continue;

            var havePh = ufPlinthoofdsoortKeysFromProduct(
              tileTagsPh,
              rowPh.title || '',
              rowPh.handle || '',
              rowPh.product_type || ''
            );
            for (var oiPh = 0; oiPh < opts.length; oiPh++) {
              var ooPh = opts[oiPh];
              var wantPh = ufPlinthoofdsoortKeyFromTag(ooPh.tag);
              if (wantPh && havePh[wantPh]) tagCount[ooPh.tag] = (tagCount[ooPh.tag] || 0) + 1;
            }
          }
        } else if (group === 'productgroep') {
          for (var tiPG = 0; tiPG < rows.length; tiPG++) {
            var rowPG = rows[tiPG];
            var pricePG = rowPG.price;
            if (isNaN(pricePG)) continue;
            if (pricePG < min || pricePG > max) continue;

            var tileTagsPG = rowPG.tags || [];

            var okOthersPG = true;
            for (var ohPG = 0; ohPG < groups.length; ohPG++) {
              var otherGroupPG = groups[ohPG];
              if (otherGroupPG === 'productgroep') continue;
              var otherSelPG = selected[otherGroupPG] || [];
              if (otherSelPG.length > 0 && !tileMatchesGroup(tileTagsPG, otherGroupPG, otherSelPG, rowPG)) {
                okOthersPG = false;
                break;
              }
            }
            if (!okOthersPG) continue;

            for (var oiPG = 0; oiPG < opts.length; oiPG++) {
              var ooPG = opts[oiPG];
              if (tileMatchesProductgroep(tileTagsPG, [ooPG.tag])) tagCount[ooPG.tag] = (tagCount[ooPG.tag] || 0) + 1;
            }
          }
        } else if (group === 'plintsoort') {
          for (var tiPl = 0; tiPl < rows.length; tiPl++) {
            var rowPl = rows[tiPl];
            var pricePl = rowPl.price;
            if (isNaN(pricePl)) continue;
            if (pricePl < min || pricePl > max) continue;

            var tileTagsPl = rowPl.tags || [];

            var okOthersPl = true;
            for (var ohPl = 0; ohPl < groups.length; ohPl++) {
              var otherGroupPl = groups[ohPl];
              if (otherGroupPl === 'plintsoort') continue;
              var otherSelPl = selected[otherGroupPl] || [];
              if (otherSelPl.length > 0 && !tileMatchesGroup(tileTagsPl, otherGroupPl, otherSelPl, rowPl)) {
                okOthersPl = false;
                break;
              }
            }
            if (!okOthersPl) continue;

            var havePl = ufPlintsoortKeysFromProduct(
              tileTagsPl,
              rowPl.title || '',
              rowPl.handle || '',
              rowPl.product_type || ''
            );
            for (var oiPl = 0; oiPl < opts.length; oiPl++) {
              var ooPl = opts[oiPl];
              var wantPl = ufPlintsoortKeyFromTag(ooPl.tag);
              if (wantPl && havePl[wantPl]) tagCount[ooPl.tag] = (tagCount[ooPl.tag] || 0) + 1;
            }
          }
        } else if (group === 'profielsoort') {
          for (var tiPf = 0; tiPf < rows.length; tiPf++) {
            var rowPf = rows[tiPf];
            var pricePf = rowPf.price;
            if (isNaN(pricePf)) continue;
            if (pricePf < min || pricePf > max) continue;

            var tileTagsPf = rowPf.tags || [];

            var okOthersPf = true;
            for (var ohPf = 0; ohPf < groups.length; ohPf++) {
              var otherGroupPf = groups[ohPf];
              if (otherGroupPf === 'profielsoort') continue;
              var otherSelPf = selected[otherGroupPf] || [];
              if (otherSelPf.length > 0 && !tileMatchesGroup(tileTagsPf, otherGroupPf, otherSelPf, rowPf)) {
                okOthersPf = false;
                break;
              }
            }
            if (!okOthersPf) continue;

            var havePf = ufProfielsoortKeysFromProduct(tileTagsPf, rowPf.title || '', rowPf.handle || '');
            for (var oiPf = 0; oiPf < opts.length; oiPf++) {
              var ooPf = opts[oiPf];
              var wantPf = ufProfielsoortKeyFromTag(ooPf.tag);
              if (wantPf && havePf[wantPf]) tagCount[ooPf.tag] = (tagCount[ooPf.tag] || 0) + 1;
            }
          }
        } else if (group === 'assortiment') {
          for (var tiA = 0; tiA < rows.length; tiA++) {
            var rowA = rows[tiA];
            var priceA = rowA.price;
            if (isNaN(priceA)) continue;
            if (priceA < min || priceA > max) continue;

            var tileTagsA = rowA.tags || [];

            var okOthersA = true;
            for (var ohA = 0; ohA < groups.length; ohA++) {
              var otherGroupA = groups[ohA];
              if (otherGroupA === 'assortiment') continue;
              var otherSelA = selected[otherGroupA] || [];
              if (otherSelA.length > 0 && !tileMatchesGroup(tileTagsA, otherGroupA, otherSelA, rowA)) {
                okOthersA = false;
                break;
              }
            }
            if (!okOthersA) continue;

            for (var oiA = 0; oiA < opts.length; oiA++) {
              var ooA = opts[oiA];
              if (tileMatchesAssortiment(tileTagsA, [ooA.tag])) tagCount[ooA.tag] = (tagCount[ooA.tag] || 0) + 1;
            }
          }
        } else if (group === 'kleur' || group === 'kleurtype') {
          for (var tiK = 0; tiK < rows.length; tiK++) {
            var rowK = rows[tiK];
            var priceK = rowK.price;
            if (isNaN(priceK)) continue;
            if (priceK < min || priceK > max) continue;

            var tileTagsK = rowK.tags || [];

            var okOthersK = true;
            for (var ohK = 0; ohK < groups.length; ohK++) {
              var otherGroupK = groups[ohK];
              if (otherGroupK === group) continue;
              var otherSelK = selected[otherGroupK] || [];
              if (otherSelK.length > 0 && !tileMatchesGroup(tileTagsK, otherGroupK, otherSelK, rowK)) {
                okOthersK = false;
                break;
              }
            }
            if (!okOthersK) continue;

            for (var oiK = 0; oiK < opts.length; oiK++) {
              var ooK = opts[oiK];
              if (tileMatchesKleurGroup(tileTagsK, [ooK.tag])) tagCount[ooK.tag] = (tagCount[ooK.tag] || 0) + 1;
            }
          }
        } else if (group === 'vgroeven') {
          for (var tiV = 0; tiV < rows.length; tiV++) {
            var rowV = rows[tiV];
            var priceV = rowV.price;
            if (isNaN(priceV)) continue;
            if (priceV < min || priceV > max) continue;

            var tileTagsV = rowV.tags || [];

            var okOthersV = true;
            for (var ohV = 0; ohV < groups.length; ohV++) {
              var otherGroupV = groups[ohV];
              if (otherGroupV === 'vgroeven') continue;
              var otherSelV = selected[otherGroupV] || [];
              if (otherSelV.length > 0 && !tileMatchesGroup(tileTagsV, otherGroupV, otherSelV, rowV)) {
                okOthersV = false;
                break;
              }
            }
            if (!okOthersV) continue;

            for (var oiV = 0; oiV < opts.length; oiV++) {
              var ooV = opts[oiV];
              var wantKeyV = ufVgroevenKeyFromTag(ooV.tag);
              if (!wantKeyV) continue;
              var hitV = false;
              for (var kv = 0; kv < tileTagsV.length; kv++) {
                if (ufVgroevenKeyFromTag(tileTagsV[kv]) === wantKeyV) {
                  hitV = true;
                  break;
                }
              }
              if (hitV) tagCount[ooV.tag] = (tagCount[ooV.tag] || 0) + 1;
            }
          }
        } else if (group === 'slijtlaag') {
          for (var tiSL = 0; tiSL < rows.length; tiSL++) {
            var rowSL = rows[tiSL];
            var priceSL = rowSL.price;
            if (isNaN(priceSL)) continue;
            if (priceSL < min || priceSL > max) continue;

            var tileTagsSL = rowSL.tags || [];

            var okOthersSL = true;
            for (var ohSL = 0; ohSL < groups.length; ohSL++) {
              var otherGroupSL = groups[ohSL];
              if (otherGroupSL === 'slijtlaag') continue;
              var otherSelSL = selected[otherGroupSL] || [];
              if (otherSelSL.length > 0 && !tileMatchesGroup(tileTagsSL, otherGroupSL, otherSelSL, rowSL)) {
                okOthersSL = false;
                break;
              }
            }
            if (!okOthersSL) continue;

            for (var oiSL = 0; oiSL < opts.length; oiSL++) {
              var ooSL = opts[oiSL];
              var wantKeySL = ufSlijtlaagKeyFromTag(ooSL.tag);
              if (!wantKeySL) continue;
              var haveKeysSL = ufSlijtlaagKeysFromProduct(tileTagsSL);
              if (haveKeysSL[wantKeySL]) tagCount[ooSL.tag] = (tagCount[ooSL.tag] || 0) + 1;
            }
          }
        } else if (group === 'lengte' || group === 'breedte' || group === 'dikte' || group === 'hoogte' || group === 'onderlaag') {
          for (var tiDim = 0; tiDim < rows.length; tiDim++) {
            var rowDim = rows[tiDim];
            var priceDim = rowDim.price;
            if (isNaN(priceDim)) continue;
            if (priceDim < min || priceDim > max) continue;

            var tileTagsDim = rowDim.tags || [];

            var okOthersDim = true;
            for (var ohDim = 0; ohDim < groups.length; ohDim++) {
              var otherGroupDim = groups[ohDim];
              if (otherGroupDim === group) continue;
              var otherSelDim = selected[otherGroupDim] || [];
              if (otherSelDim.length > 0 && !tileMatchesGroup(tileTagsDim, otherGroupDim, otherSelDim, rowDim)) {
                okOthersDim = false;
                break;
              }
            }
            if (!okOthersDim) continue;

            var haveDim = {};
            if (group === 'lengte') haveDim = ufLengteGroepKeysFromProduct(tileTagsDim, rowDim.title);
            else if (group === 'breedte') haveDim = ufBreedteGroepKeysFromProduct(tileTagsDim, rowDim.title);
            else if (group === 'dikte') haveDim = ufDikteKeysFromProduct(tileTagsDim);
            else if (group === 'hoogte') haveDim = ufHoogteKeysFromProduct(tileTagsDim);
            else haveDim = ufOnderlaagKeysFromProduct(tileTagsDim);

            for (var oiDim = 0; oiDim < opts.length; oiDim++) {
              var ooDim = opts[oiDim];
              var wantDim = '';
              if (group === 'lengte') wantDim = ufLengteGroepKeyFromTag(ooDim.tag);
              else if (group === 'breedte') wantDim = ufBreedteGroepKeyFromTag(ooDim.tag);
              else if (group === 'dikte') wantDim = ufDikteKeyFromFilterTag(ooDim.tag);
              else if (group === 'hoogte') wantDim = ufHoogteKeyFromFilterTag(ooDim.tag);
              else wantDim = ufOnderlaagKeyFromFilterTag(ooDim.tag);
              if (!wantDim || !haveDim[wantDim]) continue;
              tagCount[ooDim.tag] = (tagCount[ooDim.tag] || 0) + 1;
            }
          }
        } else if (group === 'geluid') {
          for (var tiGl = 0; tiGl < rows.length; tiGl++) {
            var rowGl = rows[tiGl];
            var priceGl = rowGl.price;
            if (isNaN(priceGl)) continue;
            if (priceGl < min || priceGl > max) continue;

            var tileTagsGl = rowGl.tags || [];

            var okOthersGl = true;
            for (var ohGl = 0; ohGl < groups.length; ohGl++) {
              var otherGroupGl = groups[ohGl];
              if (otherGroupGl === 'geluid') continue;
              var otherSelGl = selected[otherGroupGl] || [];
              if (otherSelGl.length > 0 && !tileMatchesGroup(tileTagsGl, otherGroupGl, otherSelGl, rowGl)) {
                okOthersGl = false;
                break;
              }
            }
            if (!okOthersGl) continue;

            var haveGl = ufGeluidDbKeysFromProduct(tileTagsGl);
            for (var oiGl = 0; oiGl < opts.length; oiGl++) {
              var ooGl = opts[oiGl];
              var wantGl = ufGeluidDbKeyFromTag(ooGl.tag);
              if (wantGl && haveGl[wantGl]) tagCount[ooGl.tag] = (tagCount[ooGl.tag] || 0) + 1;
            }
          }
        } else if (group === 'waterbestendig') {
          for (var tiWb = 0; tiWb < rows.length; tiWb++) {
            var rowWb = rows[tiWb];
            var priceWb = rowWb.price;
            if (isNaN(priceWb)) continue;
            if (priceWb < min || priceWb > max) continue;

            var tileTagsWb = rowWb.tags || [];

            var okOthersWb = true;
            for (var ohWb = 0; ohWb < groups.length; ohWb++) {
              var otherGroupWb = groups[ohWb];
              if (otherGroupWb === 'waterbestendig') continue;
              var otherSelWb = selected[otherGroupWb] || [];
              if (otherSelWb.length > 0 && !tileMatchesGroup(tileTagsWb, otherGroupWb, otherSelWb, rowWb)) {
                okOthersWb = false;
                break;
              }
            }
            if (!okOthersWb) continue;
            if (!ufWaterbestendigJaFromTags(tileTagsWb)) continue;

            for (var oiWb = 0; oiWb < opts.length; oiWb++) {
              var ooWb = opts[oiWb];
              tagCount[ooWb.tag] = (tagCount[ooWb.tag] || 0) + 1;
            }
          }
        } else if (group === 'vftype') {
          for (var tiVF = 0; tiVF < rows.length; tiVF++) {
            var rowVF = rows[tiVF];
            var priceVF = rowVF.price;
            if (isNaN(priceVF)) continue;
            if (priceVF < min || priceVF > max) continue;

            var tileTagsVF = rowVF.tags || [];

            var okOthersVF = true;
            for (var ohVF = 0; ohVF < groups.length; ohVF++) {
              var otherGroupVF = groups[ohVF];
              if (otherGroupVF === 'vftype') continue;
              var otherSelVF = selected[otherGroupVF] || [];
              if (otherSelVF.length > 0 && !tileMatchesGroup(tileTagsVF, otherGroupVF, otherSelVF, rowVF)) {
                okOthersVF = false;
                break;
              }
            }
            if (!okOthersVF) continue;

            if (!ufVloerverwarmingGeschiktFromTags(tileTagsVF)) continue;

            for (var oiVF = 0; oiVF < opts.length; oiVF++) {
              var ooVF = opts[oiVF];
              tagCount[ooVF.tag] = (tagCount[ooVF.tag] || 0) + 1;
            }
          }
        } else {
          for (var ti = 0; ti < rows.length; ti++) {
            var row = rows[ti];
            var price = row.price;
            if (isNaN(price)) continue;
            if (price < min || price > max) continue;

            var tileTags = row.tags || [];

            var okOthers = true;
            for (var oh = 0; oh < groups.length; oh++) {
              var otherGroup = groups[oh];
              if (otherGroup === group) continue;
              var otherSel = selected[otherGroup] || [];
              if (otherSel.length > 0 && !tileMatchesGroup(tileTags, otherGroup, otherSel, row)) {
                okOthers = false;
                break;
              }
            }
            if (!okOthers) continue;

            for (var k = 0; k < tileTags.length; k++) {
              var tag = tileTags[k];
              if (!neededSet.has(tag)) continue;
              tagCount[tag] = (tagCount[tag] || 0) + 1;
            }
          }
        }

        // Write counts back to labels
        opts.forEach(function (o) {
          var b = o.box;
          var t = o.tag;
          var labelEl = null;
          try {
            var wrapper = b.closest('label');
            labelEl = wrapper ? wrapper.querySelector('.uf-check-label') : null;
          } catch (e) {}

          if (!labelEl) return;

          var baseText = labelEl.getAttribute('data-base-label');
          if (!baseText) {
            baseText = (labelEl.textContent || '').trim().replace(/\s*\(\d+\)\s*$/, '');
            labelEl.setAttribute('data-base-label', baseText);
          }

          var count = tagCount[t] || 0;
          labelEl.textContent = baseText + ' (' + count + ')';

          var row = b.closest('li');
          if (row) {
            var gZero = b.getAttribute('data-group');
            row.hidden = count === 0 && !b.checked && gZero !== 'pvctype' && gZero !== 'merk' && gZero !== 'plinthoofdsoort';
          }
        });
      }
    }

    function init() {
      ufEnsurePaginationClickDelegate();

      var root = document.querySelector('#uf-mapped-filters');
      if (!root) {
        ufColDeferDeeplinkGridReveal = false;
        try {
          document.documentElement.classList.remove('uf-col-filter-deeplink');
        } catch (eAb) {}
        return;
      }

      var minWrap = root.querySelector('.uf-price-filter');
      if (!minWrap) {
        ufColDeferDeeplinkGridReveal = false;
        try {
          document.documentElement.classList.remove('uf-col-filter-deeplink');
        } catch (eAb2) {}
        return;
      }

      var minInput = root.querySelector('#uf-price-min');
      var maxInput = root.querySelector('#uf-price-max');
      var minText = root.querySelector('#uf-price-min-text');
      var maxText = root.querySelector('#uf-price-max-text');
      var selectedBar = root.querySelector('#uf-price-selected');
      var minMark = root.querySelector('#uf-price-min-mark');
      var maxMark = root.querySelector('#uf-price-max-mark');
      var q1 = root.querySelector('#uf-price-q1');
      var q2 = root.querySelector('#uf-price-q2');
      var q3 = root.querySelector('#uf-price-q3');
      if (!minInput || !maxInput) {
        ufColDeferDeeplinkGridReveal = false;
        try {
          document.documentElement.classList.remove('uf-col-filter-deeplink');
        } catch (eAb3) {}
        return;
      }

      /**
       * Herstel filter-UI vanuit URL (pad-tags, ?uf_group/&uf_tag, prijs, pagina).
       * fullReset: alles uitvinken vÃ³Ã³r restore (popstate / bfcache / na catalogus-merge).
       */
      function ufRestoreFiltersFromUrl(fullReset) {
        if (!root) return;

        if (fullReset) {
          root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
            b.checked = false;
          });
        }

        var baseRaw = root.getAttribute('data-collection-base');
        if (baseRaw) {
          if (window.UfFilterUrl) {
            window.UfFilterUrl.applyPathHandlesToCheckboxes(root, baseRaw);
          } else {
            var handles = ufHandlesFromPathname(baseRaw);
            if (handles.length) {
              var handleSet = {};
              for (var hi = 0; hi < handles.length; hi++) handleSet[handles[hi]] = true;
              root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
                var th = b.getAttribute('data-tag-handle');
                if (th && handleSet[th]) b.checked = true;
              });
            }
          }
        }

        try {
          var params = new URLSearchParams(window.location.search || '');
          var preProfiel = String(params.get('uf_profiel') || '').trim().toLowerCase();
          if (window.UfFilterUrl) {
            window.UfFilterUrl.applySelectionParamsToCheckboxes(root, params);
          } else {
            var preGroup = params.get('uf_group');
            var preTag = params.get('uf_tag');
            if (preGroup && preTag) {
              var tagWant = String(preTag).trim();
              var wantKey = ufFilterSelectionKey(preGroup, tagWant);
              if (preGroup === 'profieltype') {
                window.__ufNavProfieltypeFilter = tagWant;
                window.__ufNavKleurtypeFilter = null;
                var mappedProfSoort = ufProfielsoortTagFromProfieltypeNav(tagWant);
                if (mappedProfSoort) {
                  var mappedKey = ufProfielsoortKeyFromTag(mappedProfSoort);
                  root.querySelectorAll('.uf-filter-checkbox[data-group="profielsoort"]').forEach(function (b) {
                    if (ufProfielsoortKeyFromTag(b.getAttribute('data-tag')) === mappedKey) b.checked = true;
                  });
                }
              } else if (preGroup === 'kleurtype') {
                window.__ufNavKleurtypeFilter = tagWant;
              } else if (preProfiel !== 'trapprofiel') {
                window.__ufNavProfieltypeFilter = null;
                window.__ufNavKleurtypeFilter = null;
              }
              root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
                if (b.getAttribute('data-group') !== preGroup) return;
                b.checked = false;
              });
              root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
                if (b.getAttribute('data-group') !== preGroup) return;
                var dt = String(b.getAttribute('data-tag') || '').trim();
                if (dt === tagWant) {
                  b.checked = true;
                  return;
                }
                if (wantKey && ufFilterSelectionKey(preGroup, dt) === wantKey) b.checked = true;
              });
            } else if (fullReset) {
              window.__ufNavProfieltypeFilter = null;
              window.__ufNavKleurtypeFilter = null;
            }
          }
          var prePg = String(params.get('uf_pg') || '').trim().toLowerCase();
          if (preProfiel === 'trapprofiel') {
            window.__ufNavProfieltypeFilter = 'profieltype: trapprofiel';
            root.querySelectorAll('.uf-filter-checkbox[data-group="profielsoort"]').forEach(function (b) {
              if (ufProfielsoortKeyFromTag(b.getAttribute('data-tag')) === 'trapprofiel') b.checked = true;
            });
            root.querySelectorAll('.uf-filter-checkbox[data-group="plinthoofdsoort"]').forEach(function (b) {
              if (ufPlinthoofdsoortKeyFromTag(b.getAttribute('data-tag')) === 'trapprofiel') b.checked = true;
            });
          }
          if (prePg === 'plint' || prePg === 'profielen') {
            var pgKey = prePg === 'plint' ? 'plint' : 'profiel';
            root.querySelectorAll('.uf-filter-checkbox[data-group="plinthoofdsoort"]').forEach(function (b) {
              if (ufPlinthoofdsoortKeyFromTag(b.getAttribute('data-tag')) === pgKey) b.checked = true;
            });
          }
        } catch (eUfp) {}

        try {
          var ufPriceUrl = new URLSearchParams(window.location.search || '');
          var ufPmin = parseInt(ufPriceUrl.get('uf_pmin') || '', 10);
          var ufPmax = parseInt(ufPriceUrl.get('uf_pmax') || '', 10);
          var aMin = parseInt(minInput.min, 10);
          var aMax = parseInt(minInput.max, 10);
          if (fullReset || !isNaN(ufPmin) || !isNaN(ufPmax)) {
            var minV = !isNaN(ufPmin) && ufPmin >= aMin && ufPmin <= aMax ? ufPmin : aMin;
            var maxV = !isNaN(ufPmax) && ufPmax >= aMin && ufPmax <= aMax ? ufPmax : aMax;
            minInput.value = String(minV);
            maxInput.value = String(maxV);
            if (typeof syncTextInputs === 'function' && typeof updateSelectedBar === 'function') {
              syncTextInputs(minV, maxV);
              updateSelectedBar(minV, maxV);
            }
          }
        } catch (ePrUrl) {}

        if (typeof setKleurViewMode === 'function' && panelType && panelGroep && kleurWrap) {
          var typeCheckedRestore = panelType.querySelector('.uf-filter-checkbox:checked');
          if (typeCheckedRestore) setKleurViewMode('type', false);
          else setKleurViewMode('groep', false);
        }

        try {
          ufClientListPage = Math.max(
            1,
            parseInt(new URLSearchParams(window.location.search || '').get('page') || '1', 10) || 1
          );
        } catch (ePg) {
          ufClientListPage = 1;
        }

        try {
          var sortFromUrl = new URLSearchParams(window.location.search || '').get('sort_by');
          if (sortFromUrl) window.__ufCurrentCollectionSort = sortFromUrl;
        } catch (eSort) {}
      }

      /** @deprecated alias â€” deeplink-only init vÃ³Ã³r volledige catalogus */
      function ufApplyQueryParamsToFilterCheckboxes(rootEl) {
        ufRestoreFiltersFromUrl(false);
      }

      // Kleur: wissel tussen Kleur groep: en Kleurtype: (alleen Ã©Ã©n modus tegelijk actief)
      var kleurWrap = root.querySelector('.uf-kleur-filter-wrap');
      var kleurToggle = root.querySelector('.uf-kleur-mode-toggle');
      var panelGroep = root.querySelector('.uf-kleur-panel--groep');
      var panelType = root.querySelector('.uf-kleur-panel--type');

      function uncheckGroup(groupName) {
        root.querySelectorAll('.uf-filter-checkbox[data-group="' + groupName + '"]').forEach(function (cb) {
          cb.checked = false;
        });
      }

      function setKleurViewMode(mode, clearOpposite) {
        if (!kleurWrap || !panelGroep) return;
        if (mode === 'type' && !panelType) return;
        clearOpposite = clearOpposite !== false;
        if (mode === 'type') {
          kleurWrap.setAttribute('data-uf-kleur-mode', 'type');
          panelGroep.hidden = true;
          panelType.hidden = false;
          if (kleurToggle) {
            kleurToggle.textContent = '- Groepeer Kleuren';
            kleurToggle.setAttribute('aria-expanded', 'true');
          }
          if (clearOpposite) uncheckGroup('kleur');
        } else {
          kleurWrap.setAttribute('data-uf-kleur-mode', 'groep');
          panelGroep.hidden = false;
          if (panelType) panelType.hidden = true;
          if (kleurToggle) {
            kleurToggle.textContent = '+ Specifieke kleur';
            kleurToggle.setAttribute('aria-expanded', 'false');
          }
          if (clearOpposite) uncheckGroup('kleurtype');
        }
      }

      // Preselect uit URL (eerste keer; wordt na catalogus-fetch herhaald â€” zie mergeFullCollectionMeta)
      // /collections/{handle}?uf_group=kleur&uf_tag=Kleur%20groep%3A%20Licht
      // /collections/{handle}?uf_group=merk&uf_tag=Merk%3A%20Tarkett
      ufApplyQueryParamsToFilterCheckboxes(root);

      if (panelType && panelGroep && kleurWrap) {
        var typeCheckedInit = panelType.querySelector('.uf-filter-checkbox:checked');
        if (typeCheckedInit) setKleurViewMode('type', false);
        else setKleurViewMode('groep', false);
      }

      var absMin = parseInt(minInput.min, 10);
      var absMax = parseInt(minInput.max, 10);
      var span = Math.max(1, absMax - absMin);

      try {
        var ufPriceUrl = new URLSearchParams(window.location.search || '');
        var ufPmin = parseInt(ufPriceUrl.get('uf_pmin') || '', 10);
        var ufPmax = parseInt(ufPriceUrl.get('uf_pmax') || '', 10);
        if (!isNaN(ufPmin) && ufPmin >= absMin && ufPmin <= absMax) minInput.value = String(ufPmin);
        if (!isNaN(ufPmax) && ufPmax >= absMin && ufPmax <= absMax) maxInput.value = String(ufPmax);
        if (!isNaN(ufPmin) || !isNaN(ufPmax)) {
          syncTextInputs(parseInt(minInput.value, 10), parseInt(maxInput.value, 10));
          updateSelectedBar(parseInt(minInput.value, 10), parseInt(maxInput.value, 10));
        }
      } catch (ePrUrl) {}

      var UF_FILTER_DATA_CACHE_PREFIX = 'uf_filter_data_v2';

      function ufCollectionHandleFromBasePath(basePath) {
        var path = String(basePath || '')
          .split('?')[0]
          .replace(/\/$/, '');
        var m = path.match(/\/collections\/([^/]+)/i);
        if (m && m[1]) return decodeURIComponent(m[1]);
        return path.replace(/^\//, '') || '_';
      }

      function ufFilterDataStorageKey(basePath, pageNum) {
        return UF_FILTER_DATA_CACHE_PREFIX + ':' + ufCollectionHandleFromBasePath(basePath) + ':p' + String(pageNum);
      }

      function ufReadFilterDataCache(storageKey) {
        try {
          var raw = sessionStorage.getItem(storageKey);
          if (!raw) return null;
          var data = JSON.parse(raw);
          if (!data || !Array.isArray(data.products)) return null;
          return data;
        } catch (eRead) {
          try {
            sessionStorage.removeItem(storageKey);
          } catch (eRm) {}
          return null;
        }
      }

      function ufWriteFilterDataCache(storageKey, data) {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(data));
        } catch (eWrite) {
          /* quota / private mode — fetch still succeeded */
        }
      }

      function ufFetchFilterDataJson(basePath, pageNum) {
        var storageKey = ufFilterDataStorageKey(basePath, pageNum);
        var cached = ufReadFilterDataCache(storageKey);
        if (cached) return Promise.resolve(cached);
        var url = basePath + '?view=uf-filter-data&page=' + pageNum;
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('uf-filter-data');
            return r.json();
          })
          .then(function (data) {
            if (data && Array.isArray(data.products)) {
              ufWriteFilterDataCache(storageKey, data);
            }
            return data;
          });
      }

      function ufAppendFilterDataProducts(merged, list) {
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          var tags = p.tags;
          if (tags == null) tags = [];
          if (typeof tags === 'string') {
            tags = tags.length ? tags.split('||') : [];
          }
          if (!ufAccessoiresSegmentGate(tags)) continue;
          if (!ufTraprenovatieTrapprofielGate(tags, p.title || '', p.handle || '')) continue;
          var price = parseInt(p.price, 10);
          if (isNaN(price)) price = 0;
          var cap = parseInt(p.compare_at_price, 10);
          if (isNaN(cap)) cap = 0;
          var main600 = p.main_600 || p.image || '';
          if (!main600 || !String(main600).trim()) continue;
          var hasSecond = p.has_second === true || p.has_second === 'true';
          merged.push({
            id: p.id,
            handle: p.handle,
            title: p.title || '',
            product_type: p.product_type || '',
            vendor: p.vendor || '',
            url: p.url || '',
            price: price,
            compareAt: cap,
            available: p.available !== false && p.available !== 'false',
            tags: tags,
            image: main600,
            imageAlt: p.main_alt || p.image_alt || '',
            hover275: p.hover_275 || '',
            thumb144: p.thumb_144 || main600 || '',
            images600: p.images_600 || main600 || '',
            hasSecond: hasSecond,
            _ufOrder: merged.length
          });
        }
      }

      function mergeFullCollectionMeta(cb) {
        var baseRaw = root.getAttribute('data-collection-base');
        var basePath = (baseRaw && baseRaw.trim())
          ? baseRaw.split('?')[0].replace(/\/$/, '')
          : (window.location.pathname.split('?')[0] || '').replace(/\/$/, '');
        if (!basePath) basePath = '/';
        var merged = [];

        ufFetchFilterDataJson(basePath, 1)
          .then(function (first) {
            ufAppendFilterDataProducts(merged, first.products || []);
            var totalPages = parseInt(first.pages, 10) || 1;
            if (totalPages <= 1) return null;
            var rest = [];
            for (var pg = 2; pg <= totalPages; pg++) {
              rest.push(ufFetchFilterDataJson(basePath, pg));
            }
            return Promise.all(rest);
          })
          .then(function (morePages) {
            if (morePages && morePages.length) {
              for (var mi = 0; mi < morePages.length; mi++) {
                ufAppendFilterDataProducts(merged, (morePages[mi] && morePages[mi].products) || []);
              }
            }
            ufProductCatalog = merged;
            ufCollectionCountRows = merged.map(function (row) {
              return {
                price: row.price,
                tags: row.tags,
                title: row.title || '',
                product_type: row.product_type || '',
                vendor: row.vendor || ''
              };
            });
            cb(merged);
          })
          .catch(function () {
            cb(null);
          });
      }

      function centsToInput(cents) {
        var n = parseFloat(cents || '0') / 100;
        return n.toFixed(2).replace('.', ',');
      }

      function inputToCents(v) {
        var raw = String(v || '').trim().replace(/[^\d,.-]/g, '').replace(',', '.');
        var parsed = parseFloat(raw);
        if (isNaN(parsed)) return null;
        return Math.round(parsed * 100);
      }

      function centsPipLabel(cents) {
        return String(Math.round(parseFloat(cents || 0) / 100));
      }

      function updatePriceMarks() {
        if (minMark) minMark.textContent = centsPipLabel(absMin);
        if (q1) q1.textContent = centsPipLabel(Math.round(absMin + span * 0.25));
        if (q2) q2.textContent = centsPipLabel(Math.round(absMin + span * 0.5));
        if (q3) q3.textContent = centsPipLabel(Math.round(absMin + span * 0.75));
        if (maxMark) maxMark.textContent = centsPipLabel(absMax);
      }

      function updateSelectedBar(minV, maxV) {
        if (!selectedBar) return;
        var left = ((minV - absMin) / span) * 100;
        var right = ((maxV - absMin) / span) * 100;
        var width = Math.max(0, right - left);
        selectedBar.style.left = left + '%';
        selectedBar.style.width = width + '%';
        selectedBar.style.right = 'auto';
      }

      function syncTextInputs(minV, maxV) {
        if (minText) minText.value = centsToInput(minV);
        if (maxText) maxText.value = centsToInput(maxV);
      }

      function normalizeAndSet(minV, maxV, sourceEl) {
        if (minV > maxV) {
          if (sourceEl === minInput || sourceEl === minText) maxV = minV;
          else if (sourceEl === maxInput || sourceEl === maxText) minV = maxV;
          else {
            var lo = Math.min(minV, maxV);
            var hi = Math.max(minV, maxV);
            minV = lo;
            maxV = hi;
          }
        }
        if (minV < absMin) minV = absMin;
        if (maxV > absMax) maxV = absMax;
        minInput.value = minV;
        maxInput.value = maxV;
        syncTextInputs(minV, maxV);
        updateSelectedBar(minV, maxV);
        return { minV: minV, maxV: maxV };
      }

      function applyFilters(sourceEl) {
        var minV = parseInt(minInput.value, 10);
        var maxV = parseInt(maxInput.value, 10);
        var norm = normalizeAndSet(minV, maxV, sourceEl);
        applyAllFilters(norm.minV, norm.maxV);
        if (window.ufTrack) {
          window.__ufFilterTrackT && clearTimeout(window.__ufFilterTrackT);
          window.__ufFilterTrackT = setTimeout(function () {
            window.ufTrack('filter_change', {
              min: norm.minV,
              max: norm.maxV,
              path: window.location.pathname + window.location.search
            });
          }, 900);
        }
      }

      function ufSyncActiveFiltersBar() {
        var bar = document.getElementById('uf-active-filters-bar');
        var chipsEl = document.getElementById('uf-active-filters-bar__chips');
        var clearBtn = document.getElementById('uf-active-filters-clear-all');
        if (!bar || !chipsEl) return;

        var amin = absMin;
        var amax = absMax;
        var minV = parseInt(minInput.value, 10);
        var maxV = parseInt(maxInput.value, 10);
        var priceNarrow =
          isFinite(minV) &&
          isFinite(maxV) &&
          isFinite(amin) &&
          isFinite(amax) &&
          span > 0 &&
          (minV > amin || maxV < amax);

        var parts = [];
        root.querySelectorAll('.uf-filter-checkbox:checked').forEach(function (b) {
          var g = b.getAttribute('data-group') || '';
          var t = b.getAttribute('data-tag') || '';
          var label = '';
          try {
            var lw = b.closest('label');
            var lb = lw ? lw.querySelector('.uf-check-label') : null;
            label = lb ? (lb.textContent || '').trim().replace(/\s*\(\d+\)\s*$/, '') : '';
          } catch (eLb) {}
          if (!label) label = ufFilterTagDisplayLabel(t) || g;
          parts.push(
            '<button type="button" class="uf-active-filters-bar__chip" data-uf-af-remove="tag" data-uf-af-group="' +
              ufEscapeAttr(g) +
              '" data-uf-af-tag-enc="' +
              encodeURIComponent(t) +
              '" aria-label="Filter verwijderen: ' +
              ufEscapeAttr(label) +
              '"><span class="uf-active-filters-bar__chip-label">' +
              ufEscapeHtml(label) +
              '</span><span class="uf-active-filters-bar__chip-x" aria-hidden="true">\u00d7</span></button>'
          );
        });

        if (priceNarrow) {
          var ptxt =
            'Prijs: ' +
            (minText && minText.value ? minText.value : centsToInput(minV)) +
            ' \u2013 ' +
            (maxText && maxText.value ? maxText.value : centsToInput(maxV)) +
            ' \u20ac';
          parts.push(
            '<button type="button" class="uf-active-filters-bar__chip uf-active-filters-bar__chip--price" data-uf-af-remove="price" aria-label="Prijsfilter wissen"><span class="uf-active-filters-bar__chip-label">' +
              ufEscapeHtml(ptxt) +
              '</span><span class="uf-active-filters-bar__chip-x" aria-hidden="true">\u00d7</span></button>'
          );
        }

        chipsEl.innerHTML = parts.join('');
        var n = parts.length;
        if (clearBtn) clearBtn.hidden = n === 0;
        bar.hidden = n === 0;
      }

      window.__ufSyncActiveFiltersBar = ufSyncActiveFiltersBar;

      window.__ufFilterHistoryApply = function () {
        ufFilterApplyingFromHistory = true;
        ufRestoreFiltersFromUrl(true);
        applyFilters(null);
        ufFilterApplyingFromHistory = false;
      };

      var ufAfbBar = document.getElementById('uf-active-filters-bar');
      var ufAfbClearBtn = document.getElementById('uf-active-filters-clear-all');
      if (ufAfbBar) {
        ufAfbBar.addEventListener('click', function (e) {
          var chip = e.target && e.target.closest ? e.target.closest('[data-uf-af-remove]') : null;
          if (chip) {
            e.preventDefault();
            var kind = chip.getAttribute('data-uf-af-remove');
            if (kind === 'price') {
              normalizeAndSet(absMin, absMax, null);
              applyFilters(minInput);
              return;
            }
            if (kind === 'tag') {
              var g = chip.getAttribute('data-uf-af-group') || '';
              var tenc = chip.getAttribute('data-uf-af-tag-enc') || '';
              var t = '';
              try {
                t = decodeURIComponent(tenc);
              } catch (eDec) {
                t = tenc;
              }
              root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
                if (b.getAttribute('data-group') === g && b.getAttribute('data-tag') === t) {
                  b.checked = false;
                }
              });
              applyFilters(minInput);
            }
            return;
          }
          if (
            ufAfbClearBtn &&
            (e.target === ufAfbClearBtn || (e.target.closest && e.target.closest('#uf-active-filters-clear-all')))
          ) {
            e.preventDefault();
            root.querySelectorAll('.uf-filter-checkbox').forEach(function (b) {
              b.checked = false;
            });
            window.__ufNavProfieltypeFilter = null;
            window.__ufNavKleurtypeFilter = null;
            normalizeAndSet(absMin, absMax, null);
            applyFilters(minInput);
          }
        });
      }

      function syncUISliders(sourceEl) {
        var minV = parseInt(minInput.value, 10);
        var maxV = parseInt(maxInput.value, 10);
        normalizeAndSet(minV, maxV, sourceEl);
      }

      minInput.addEventListener('input', function () { syncUISliders(minInput); });
      minInput.addEventListener('change', function () { applyFilters(minInput); });
      maxInput.addEventListener('input', function () { syncUISliders(maxInput); });
      maxInput.addEventListener('change', function () { applyFilters(maxInput); });

      function applyFromText(sourceEl) {
        var minV = inputToCents(minText ? minText.value : minInput.value);
        var maxV = inputToCents(maxText ? maxText.value : maxInput.value);
        if (minV === null) minV = parseInt(minInput.value, 10);
        if (maxV === null) maxV = parseInt(maxInput.value, 10);
        var norm = normalizeAndSet(minV, maxV, sourceEl);
        applyAllFilters(norm.minV, norm.maxV);
      }

      if (minText) {
        minText.addEventListener('change', function () { applyFromText(minText); });
        minText.addEventListener('blur', function () { applyFromText(minText); });
      }
      if (maxText) {
        maxText.addEventListener('change', function () { applyFromText(maxText); });
        maxText.addEventListener('blur', function () { applyFromText(maxText); });
      }

      var applyBtn = root.querySelector('#uf-price-apply');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          applyFromText(null);
        });
      }

      root.addEventListener('change', function (ev) {
        var t = ev.target;
        if (!t || !t.classList || !t.classList.contains('uf-filter-checkbox')) return;
        if (t.getAttribute('data-group') === 'plinthoofdsoort' && root.getAttribute('data-uf-plinten') === 'true') {
          ufSyncPlintenSubfilterVisibility(root);
        }
        applyFilters();
      });

      if (kleurToggle && panelGroep && panelType) {
        kleurToggle.addEventListener('click', function (e) {
          e.preventDefault();
          var mode = kleurWrap.getAttribute('data-uf-kleur-mode') || 'groep';
          if (mode === 'groep') setKleurViewMode('type', true);
          else setKleurViewMode('groep', true);
          applyFilters();
        });
      }

      ufSortAllMappedFilterLists(root);
      ufEnsureSoortFilterOptions(root, []);
      ufApplyQueryParamsToFilterCheckboxes(root);
      ufHideEmptyFilterSections(root);
      ufInitFilterNormalizationCaches(root, null);

      // initial values (eerst huidige pagina; daarna hele collectie voor tellingen + prijsrange)
      updatePriceMarks();
      applyFilters(minInput);

      mergeFullCollectionMeta(function (merged) {
        if (!merged || !merged.length) {
          ufColDeferDeeplinkGridReveal = false;
          applyFilters(minInput);
          return;
        }
        ufSyncPlintenProductgroepFilterOptions(root, merged);
        ufSyncPlintsoortFilterOptions(root, merged);
        ufSyncProfielsoortFilterOptions(root, merged);
        ufSyncHoogteFilterOptions(root, merged);
        ufSyncPlintenDikteFilterOptions(root, merged);
        ufSyncPvctypeFilterOptions(root, merged);
        ufEnsureSoortFilterOptions(root, merged);
        ufSyncAssortimentFilterOptions(root, merged);
        ufSyncAccsoortFilterOptions(root, merged);
        ufSyncMerkFilterOptions(root, merged);
        ufSyncKleurGroepFilterOptions(root, merged);
        ufInitFilterNormalizationCaches(root, merged);
        ufSyncGeluidFilterOptions(root, merged);
        ufSyncOnderlaagFilterOptions(root, merged);
        ufApplyQueryParamsToFilterCheckboxes(root);
        ufFillKleurThumbsFromCatalog();
        ufSortAllMappedFilterLists(root);
        ufHideEmptyFilterSections(root);
        var gmin = Infinity;
        var gmax = -Infinity;
        for (var mi = 0; mi < merged.length; mi++) {
          var pv = merged[mi].price;
          if (pv < gmin) gmin = pv;
          if (pv > gmax) gmax = pv;
        }
        if (!isFinite(gmin) || !isFinite(gmax) || gmax < gmin) {
          ufColDeferDeeplinkGridReveal = false;
          applyFilters(minInput);
          return;
        }

        absMin = gmin;
        absMax = gmax;
        span = Math.max(1, absMax - absMin);
        minInput.min = String(absMin);
        minInput.max = String(absMax);
        maxInput.min = String(absMin);
        maxInput.max = String(absMax);

        /* Default volledige prijsrange; behoud smalle range uit URL indien aanwezig. */
        minInput.value = absMin;
        maxInput.value = absMax;
        try {
          var ufPriceUrlMerge = new URLSearchParams(window.location.search || '');
          var ufPminMerge = parseInt(ufPriceUrlMerge.get('uf_pmin') || '', 10);
          var ufPmaxMerge = parseInt(ufPriceUrlMerge.get('uf_pmax') || '', 10);
          if (!isNaN(ufPminMerge) && ufPminMerge >= absMin && ufPminMerge <= absMax) minInput.value = String(ufPminMerge);
          if (!isNaN(ufPmaxMerge) && ufPmaxMerge >= absMin && ufPmaxMerge <= absMax) maxInput.value = String(ufPmaxMerge);
        } catch (ePrMerge) {}
        syncTextInputs(parseInt(minInput.value, 10), parseInt(maxInput.value, 10));
        updatePriceMarks();
        updateSelectedBar(parseInt(minInput.value, 10), parseInt(maxInput.value, 10));

        ufLastFilterKey = null;
        ufColDeferDeeplinkGridReveal = false;
        ufRestoreFiltersFromUrl(true);
        ufFiltersHistoryReady = true;
        applyFilters(minInput);
        ufSyncFilterUrlToCheckboxes(false);
      });
    }

    function ufOnFilterHistoryNavigation() {
      if (!document.getElementById('uf-mapped-filters')) return;
      ufClearBreadcrumbFilterSegments();
      if (typeof window.__ufFilterHistoryApply !== 'function') return;
      window.__ufFilterHistoryApply();
    }

    if (!window.__ufFilterPopstateBound) {
      window.__ufFilterPopstateBound = true;
      window.addEventListener('popstate', ufOnFilterHistoryNavigation);
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) ufOnFilterHistoryNavigation();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }());
